



























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
// Constants
import {
  EditButtons,
  RelatedDatastoreNames,
  RelatedDatastoreNamesOA,
  RelatedDatastoreNamesGeneral,
  RelatedDatastoreNamesFJapan,
  MatterInfomationRegisterData,
  MaterialListTabItems,
  MatterTabItems,
  MasterSelectDataColumns,
  MasterSelectDataBodies,
  PaymentTypeItem,
  SearchItems,
  ExclusionStatus,
  CopyDSNames,
  CopyDSNamesOA,
  CopyDSNamesGeneral,
  CopyDSNamesFJapan,
  MatterHeaderColumns,
  ContractSendData,
  DocumentStatus,
  previewDialog,
  sendCompletedDialog,
  CreditProductColumns,
  CreditProductSearchLargeItemData,
  CreditProductSearchSmallItemData
} from '@/constants/matter/matter';
import { DefaultListData } from '@/constants/matter/advanceCreditInformation';
import { DSNames } from '@/constants/dataStore';
// Types
import {
  GetInputFieldsActons,
  StatusList,
  StatusActions,
  ItemActions,
  ActionButtons,
  FieldChildrenProp,
  GetAutoNumberResponse,
  actionList,
  ActionFieldSeeting,
  FieldsInfo
} from '@/services/hexabase/types';
import { SelectItemProps, TabItemProps } from '@/constants/matter/types';
// Models
import Matter from '@/models/matterModel';
import Estimate from '@/models/estimateModel';
import Customer from '@/models/customerModel';
import FileClass from '@/models/lib/file';
// Components
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import Dialog from '@/components/common/modules/Dialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import InputNoVModel from '@/components/common/elements/InputNoVModel.vue';
import SelectNoVModel from '@/components/common/elements/SelectNoVModel.vue';
import MasterSelectSetControl from '@/components/common/modules/MasterSelectSetControl.vue';
import MasterSelectMultiSetControl from '@/components/common/modules/MasterSelectMultiSetControl.vue';
import TabPanel from '@/components/common/modules/TabPanel.vue';
import StatusBox from '@/components/common/modules/StatusBox.vue';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue';
import IconTextLink from '@/components/common/elements/IconTextLink.vue';
import { ItemData } from '@/constants/components/dialogMasterSelectMultiControlTable';
import HeaderPanel from '@/components/common/modules/HeaderPanel.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import {
  matterEditOptionalForm,
  matterOptionalChangeForm 
} from '@/constants/form/matterForm';
import {
  fileUploadItemForms,
  partnerSignaturePositionItemForms,
  ourSignaturePositionItemForms,
  contractInfomationDetailForms,
  contractInfomationConfirmForms
} from '@/constants/form/contractInfomationTabForm';
import { entryItemForms, readonlyItemForms } from '@/constants/form/applyInfomationTabForm';

import Simwork from '@/services/simwork/simwork';
import { DateTime } from 'luxon';

import { mapFormat, contentType, initialSearchCondition, inputNames } from '@/constants/docurain/docurain';

import StatusStep from '@/components/common/modules/StatusStep.vue';
import appState from '@/store/app';
import * as materialList from '@/constants/matter/materialList';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    TransitionDialog,
    Dialog,
    ExecAction,
    TabPanel,
    InputNoVModel,
    SelectNoVModel,
    MasterSelectSetControl,
    MasterSelectMultiSetControl,
    StatusBox,
    ActionButtonPanel,
    IconTextLink,
    HeaderPanel,
    AutoCreateForm,
    StatusStep
  },
  beforeRouteEnter(to: Route, from: Route, next: any): void {
    next((vm: any) => {
      vm.prevRoute = from;
      next();
    });
  },
  beforeRouteUpdate(to, from, next) {
    // URL変更前
    next();
    // URL変更後
    // URL変更のタイミングで再描画する
    if (to.path !== from.path) {
      this.$router.go(0);
    }
  }
})
/* eslint-disable @typescript-eslint/camelcase */
export default class MatterEdit extends Vue {
  private matter = new Matter();
  private estimate = new Estimate();
  private customer = new Customer();
  private File = new FileClass();
  private simwork = new Simwork();

  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';
  private currentData: Array<FieldsInfo> = [];

  private prevRoute: any = null;
  private urlParams: any = {};
  private projectId = hexabaseState.applicationId;
  private displayStatus = '';

  private editable = false;
  private screenStructureType: any = null;
  private serviceType: any = null;
  // Header
  private matterHeaderData: any = {};
  // Action
  private statusList: Array<StatusList> = [];
  private statusButton: Array<StatusActions> = [];
  private statusAction: Array<StatusActions> = [];
  private itemActions: Array<ItemActions> = [];
  private execAllowActions: Array<ActionButtons> = [];
  private execAllowActionsByDetail: Array<ActionButtons> = [];
  private selectAction = '';
  private buttonCrudType = '';
  private buttonActionName = '';
  // TabPanel's property
  private materialListTabItems: Array<TabItemProps> = [];
  private matterTabItems: Array<TabItemProps> = [];
  // Master
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
  private masterSelectDataColumn: any = [];
  private masterSelectData: any = [];
  private masterSelectDataColumns = JSON.parse(JSON.stringify(MasterSelectDataColumns));
  private masterSelectDataBodies = JSON.parse(JSON.stringify(MasterSelectDataBodies));
  private paymentInformationLists: any = {};
  private leasingCompanyFields: any = {};
  // Field
  private projectServiceFields: any = {};
  private estimateBasicInfoOaFields: any = {};
  private estimateBasicInfoGeneralFields: any = {};
  private estimateBasicInfoFJapanFields: any = {};
  private rateFields: any = {};
  private commodityFields: any = {};
  private creditProductFields: any = {};
  private projectCreditFields: any = {};
  private finalQuoteItems: any = [];
  private estimateItems: any = [];
  private creditItems: any = [];
  // Datasotre
  private matterFields!: GetInputFieldsActons;
  private relatedFields: { [key: string]: GetInputFieldsActons } = {};
  private copyRelatedFields: { [key: string]: GetInputFieldsActons } = {};
  // Dropdown's properties
  private leasingCompanyColumns: any = [];
  private leasingCompanyDatas: any = [];
  private customerDepartmentPaymentInfomationItem: SelectItemProps = JSON.parse(
    JSON.stringify(PaymentTypeItem)
  );
  private paymentInfomationItem: SelectItemProps = JSON.parse(JSON.stringify(PaymentTypeItem));
  private selectCreditStatusItem: any = [];
  private checkStatusItem: any = [];
  // MasterSelect's properties
  private searchItems = SearchItems;
  private masterSelectCustomerData: any = [];
  private masterSelectCustomerDepartmentData: any = [];
  private masterSelectServiceTypeData: any = [];
  private masterSelectCustomerSelected: any = null;
  private masterSelectCustomerDepartmentFromSelected: any = null;
  private masterSelectCustomerDepartmentToSelected: any = null;
  private masterSelectServiceTypeSelected: any = null;

  // アクション実行ボタン押下後ダイアログ
  private execActionMessage = 'この内容でよろしければ実行ボタンを押してください';
  private execActionMessageStyle = 'action-area__message';

  // アイテム登録後ダイアログ
  private guideMessage = '';
  private dialogStatus = false;
  private isLoading = false;
  private registerText = '編集が完了いたしました';
  private buttons: any = JSON.parse(JSON.stringify(EditButtons));

  // Dialog
  private isExecDialog = false;
  private redirectTargetParam: any;
  private execDialogTitle = '画面遷移確認';
  private execDialogMessage =
    '画面遷移を行うと入力中の内容は保存されません。遷移しても良いですか？';

  private openExecActionDialog = true;
  private isFinalEstimateDialog = false;
  private FinalEstimateDialogCancel = false;
  private FinalEstimateDialogOK = '閉じる';
  private FinalEstimateDialogMessage =
    '最終見積に採用された見積が存在しません。\n案件に登録された見積のうち、いずれかの見積を\n見積詳細画面から最終見積に採用してください。';
  // Data stock
  private matterInfomationRegisterData: any = null;
  private matterItemId: any = '';
  private matterData: any = null;

  // File
  private currentFiles: any = [];
  private inputFiles: any = [];
  private fileRevNo: any = 0;
  private fileCount: any = 0;
  // 親の顧客レコードアイテムID
  private customerItemId = '';

  // 契約タブ内署名依頼時の送信データ
  private contractSendData: any = {};
  private contractDocumentData: any = {};
  // 契約情報
  private contractInfomationItems: any = {};
  private documentManagementItems: any = {};

  private contractTemplateSelectData: any = {};
  private signingGroupData: any = {};
  private contractInfomationItemId = '';

  private nonContractCurrentFiles: any = [];
  private nonContractinputFiles: any = [];
  private nonContractFileRevNo: any = 0;
  private nonContractFileCount: any = 0;

  // メール本文退避
  private mailTextBackUp = '';

  // 汎用ダイアログ
  private isGeneralDialog = false;
  private generalDialogTitle = '';
  private generalDialogMessage = '';
  private generalDialogCancel = false;

  private inputFields: any = [];
  private fieldsData: any = [];
  private customerItemDetail: any = [];
  private projectServiceOa: any = [];
  private projectServiceGeneral: any = [];
  private projectServiceFJapan: any = [];
  private matterLinkedItem: any = [];

  // 案件与信一覧用削除データ格納用
  private registProjectCreditDeleteData: any = [];
  // 案件与信一覧 与信商品マスタ検索
  private masterCreditProductData: any = [];
  private masterCreditProductSelectItem = {
    title: '与信商品マスタ',
    column: CreditProductColumns,
    data: this.masterCreditProductData,
    searchItemData: {
      searchLargeItemData: CreditProductSearchLargeItemData,
      searchSmallItemData: CreditProductSearchSmallItemData,
      freeFormatLabelName: '商品名',
      freeFormatLabelDisplayId: 'prodact_name',
      labelName: ['リース会社名', '商品区分']
    }
  };
  // 申込情報ダイアログ入力内容一時格納用
  private applyDialogEntryItems: any = {};

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  // dbID格納プロパティ
  private mainDsId = '';
  private customerDsId = '';
  private projectServiceDsId = '';
  private estimateDsId = '';
  private creditDsId = '';
  private fileUploadTarget = {
    datastoreId: '',
    itemId: '',
    fieldId: 'estimate_file'
  };

  // itemID格納プロパティ
  private estimateItemId = '';
  private projectServiceOAItemId = '';

  private selectAdvanceCredit:any = [];
  private parseDisplayOrder:any = [];

  // 最終見積確定データ
  private estimateInformationData:any = null;
  private estimateFixecdLeasingCompany:any = null;

  // 登録用情報格納プロパティ
  private registData: any = {
    'use_display_id': true,
    'ensure_transaction': true,
    'action_id': '',
    'item': {},
    'related_ds_items': {}
  };

  // 更新プロパティ
  private buttonType = '';

  // 契約情報取得フラグ
  private getContractDataFlag = false;
  // StatusStepでのステータス表示用
  private statusListViewData: Array<StatusList> = [];

  // ファイル送信タブ関連
  private sendTargetService: any = {};
  private projectService = '';
  private fileSendParams: any = {};

  // 契約書itemID
  private contractInformationDetailItemId = '';
  private documentRevNo: any = null;
  // 案件ステータス自動更新フラグ
  private matterStatusUpdateFlag = false;

  // 案件基本情報の一部の項目の値の格納用
  private matterOutputDatas: any = [];
  // メールプレビュー用変数の格納用
  private previewValue: any = '';
  // メールプレビュー用ファイル名の格納用
  private attachmentFileNames: any = '';
  private sendTargetFileNames: any = '';

  async created() {
    try {
      // ローディングをセット
      this.setLoading(true);
      this.mainDsId = hexabaseState.datastoreIds['案件基本情報'];
      this.customerDsId = hexabaseState.datastoreIds['顧客マスタ'];

      this.matterInfomationRegisterData = JSON.parse(JSON.stringify(MatterInfomationRegisterData));

      const addPromises: any = [];
      addPromises.push(this.getMatterDatas());
      addPromises.push(this.getMasterData());
      addPromises.push(this.matter.getStatusList(this.projectId, this.mainDsId).then(data => data[0].statuses));
      addPromises.push(this.matter
        .getField(this.projectId, hexabaseState.datastoreIds['料率マスタ'])
        .then(response => {
          this.rateFields = response;
        })
      );
      addPromises.push(this.matter
        .getField(this.projectId, hexabaseState.datastoreIds['商材マスタ'])
        .then(response => {
          this.commodityFields = response;
        }),
      );
      const results = await Promise.all(addPromises);
      const matterDatas:any = results[0];
      const mnasterData:any = results[1];
      const displayStatus:any = results[2];

      if (matterDatas !== undefined) {
        this.currentData = matterDatas.field_values;
        // actions
        this.statusAction = matterDatas.status_actions;
        this.itemActions = matterDatas.item_actions;
        this.statusList = matterDatas.status_list;

        this.displayStatus = displayStatus ? displayStatus[0].status_name : 'ステータス取得失敗';
      }

      await this.getInitialValues(matterDatas);
      await this.nowActiveTab({ title: '契約' }, false);

      // StatusStepでのステータス表示用データをサービス種別に合わせて作成
      this.statusListViewData = this.matter.deepCopy(matterDatas.status_list).filter((item:any) => {
        const service:any = this.masterData.m_service_type.body.find(
          (service: any) => service.service_type === this.serviceType
        );
        if (item.display_id.indexOf(service.status_type)!== -1) {
          return item;
        }
      });

      // TODO:20220906 FT様向けデモ用に非表示、サービス種別ごとに項目表示する為の検討が必要
      for (const index in this.basicFieldsData) {
        if ( this.basicFieldsData[index].display_id.indexOf('general_item_') != -1) {
          this.basicFieldsData[index].show = false;
        }
      }
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.setLoading(false);
    }
  }

  private async getMatterDatas() {
    if (Object.keys(this.$route.params).length > 0) {
      const matterItemId = this.$route.params.id;

      if (matterItemId) {
        this.matterItemId = matterItemId;
        // Get datas from application
        const matterDatas = this.matter.getLinkedItems(
          this.projectId,
          this.mainDsId,
          matterItemId
        );
        return matterDatas;
      }
    }
  }

  private async buttonAction(type: string) {
    try {
      this.openExecActionDialog = true;
      if (type === 'project_basic_info_completed') {
        this.openExecActionDialog = this.isFinalEstimate();
        this.execActionMessage = '注文確定（請求対象）となります。よろしいですか？';
        this.execActionMessageStyle = 'action-area__message_strong';
      }

      if (!this.openExecActionDialog) {
        // 最終見積が存在しない場合はダイアログ表示
        this.isFinalEstimateDialog = true;
      } else {
        this.setLoading(true);
        const button = this.statusButton.find(v => v.display_id === type);
        this.buttonCrudType = button!.crud_type;
        this.buttonActionName = button!.action_name;

        // アクション毎の見出し要素入力制限反映
        const copy = this.matter.modifyButtonProp(this.execAllowActions, type);
        if (copy !== undefined && copy.length > 0) {
          this.execAllowActions.splice(0, copy.length, ...copy);
        }
        const execAction = this.execAllowActions.find(action => action.display_id === type);
        if (execAction !== undefined) {
          this.selectAction = execAction.display_id;
        }

        const basicResult = await this.modifyFields(
          this.mainDsId,
          this.basicFieldsData,
          execAction!,
          type,
          false
        );
        const basicResultFormat = basicResult as Array<FieldChildrenProp>;

        // 参照専用アクションかどうかを判断する
        if (!type.includes('_update')) {
          // 参照専用と見なして、全項目をdisabledとする
          this.addInputProhibited(basicResultFormat);
        } else {
          // 構成表タブ
          const materialListTabItem = this.materialListTabItems.find(
            v => v.component === 'MaterialListTab'
          );
          this.$set(materialListTabItem!, 'isFileManagerDisabled', false);
          materialListTabItem!.tableParameters.buttonItems.forEach(
            (buttonItem: any, index: number) => {
              if (buttonItem.name === 'fileAttach') {
                this.$set(buttonItem, 'disabled', false);
              }
            }
          );
          // 案件基本情報のステータスに応じて、参照する子テーブルのアクションを特定する
          // ToDo: 現状はステータスごとにアクションを用意せず、見積作成中の「編集する」アクションかそれ以外でアクションを決定している
          const statusRelatedAction =
            type === 'project_basic_info_estimate_create_update'
              ? type + '_setting'
              : 'others_setting';

          // 編集時はメールプレビューボタンを非活性
          this.matterTabItems.find((item: any) => {
            if(item.title === '送信'){
              this.$set(item, 'isDisabledPreviewButton', true);
            }
          });

          // サービス種別を見てタブ内容の設定を変更する
          if (this.screenStructureType === '1') {
            const [
              projectCreditOASettingActionId,
              projectServiceOASettingActionId
            ] = await Promise.all([
              this.getSettingActionId(hexabaseState.datastoreIds['案件与信OA'], statusRelatedAction),
              this.getSettingActionId(
                hexabaseState.datastoreIds['案件サービス別OA'],
                statusRelatedAction
              )
            ]);
            // 本信タブ、確定見積タブは案件サービス別OAテーブルの設定を参照
            const [projectCreditOASetting, projectServiceOASetting] = await Promise.all([
              this.matter.getFieldsByActionId(
                hexabaseState.datastoreIds['案件与信OA'],
                projectCreditOASettingActionId
              ),
              this.matter.getFieldsByActionId(
                hexabaseState.datastoreIds['案件サービス別OA'],
                projectServiceOASettingActionId
              )
            ]);

            // 与信タブ
            const advanceCreditInformationTabItem = this.matterTabItems.find(
              v => v.component === 'AdvanceCreditInformationTab'
            );
            // 確定見積タブ
            const fixedMatterInformationTabItem = this.matterTabItems.find(
              v => v.component === 'FixedMatterInformationTab'
            );
            // 本信タブ
            const mainCreditInfomationTabItem = this.matterTabItems.find(
              v => v.component === 'MainCreditInfomationTab'
            );

            for (const key in projectServiceOASetting.action_field_settings) {
              const propertyKey = projectServiceOASetting.action_fields[key].display_id;
              // アクションに紐づく入力可否を設定
              // if (
              //   projectServiceOASetting.action_field_settings[key].update &&
              //   propertyKey in fixedMatterInformationTabItem!.editable
              // ) {
              //   this.$set(fixedMatterInformationTabItem!.editable, propertyKey, true);
              // }
              if (
                projectServiceOASetting.action_field_settings[key].update &&
                propertyKey in mainCreditInfomationTabItem!.editable
              ) {
                this.$set(mainCreditInfomationTabItem!.editable, propertyKey, true);
                this.$set(mainCreditInfomationTabItem!.editable, 'leasing_company_id', false);
              }
              // アクションに紐づく必須項目を設定
              if (projectServiceOASetting.action_field_settings[key].mandatory) {
                this.$set(
                  fixedMatterInformationTabItem!.rules,
                  propertyKey,
                  'table_input_item_required'
                );
                this.$set(
                  mainCreditInfomationTabItem!.rules,
                  propertyKey,
                  'table_input_item_required'
                );
              }
            }
            // 事前与信タブを編集可に設定
            advanceCreditInformationTabItem!.creditList.tableParameters.buttonItems =
              materialList.ProjectCreditButtonItems;
            advanceCreditInformationTabItem!.creditList.tableParameters.inputItems = materialList.ProjectCreditInputItems;
            advanceCreditInformationTabItem!.creditList.tableParameters.inputItems[0].options = this.checkStatusItem;
            advanceCreditInformationTabItem!.creditList.tableParameters.isDisabledNoteEdit = false;
            advanceCreditInformationTabItem!.creditList.isDisabledAddItemButtonFlag = false;
          }
        }
        this.basicFieldsData = basicResultFormat;
        this.selectAction = execAction!.display_id;
        this.setTabItems();
      }
    } finally {
      if (this.openExecActionDialog) {
        this.statusButton = [
          ...this.matter.statusButtonList(this.execAllowActions, this.matterData, type)
        ];
      }
      // TODO:20220906 FT様向けデモ用に非表示、サービス種別ごとに項目表示する為の検討が必要
      for (const index in this.basicFieldsData) {
        if ( this.basicFieldsData[index].display_id.indexOf('general_item_') != -1) {
          this.basicFieldsData[index].show = false;
        }
      }

      this.setLoading(false);
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: any) {
    switch (type) {
      case 'cancel': {
        this.$router.go(0);
        break;
      }
      case 'exec': {
        try {
          // ローディングをセット
          this.setLoading(true);
          
          // 売上予定月・工事完了予定日から売上見込日の設定と工事完了日の判定
          this.matter.setExpectedSalesDate(this.matterInfomationRegisterData);

          // APIリクエスト
          const request = await this.createRequestData();
          // ToDo: 顧客が変更された場合にoperation: 12で元の関連を切る必要があり
          if (this.buttonCrudType === '4') {
            // コピー元の案件基本情報とコピーして新規登録する見積基本情報(OA・汎用)を関連付ける
            request['related_ds_items'][this.customerDsId] = [
              {
                operation: 11,
                link_to_parent: true,
                i_id: this.customerItemId
              }
            ];
          }

          // 事前与信情報 案件与信OA更新
          if (this.screenStructureType === '1') {
            const projectServiceOa = await this.matter.getLinkedItems(
              this.projectId,
              this.projectServiceDsId,
              this.matterInfomationRegisterData.relatedItems.projectServiceOA.i_id
            );
            const projectCredit = this.matterInfomationRegisterData.relatedItems.projectServiceOA
              .projectCredit;
            this.registData['related_ds_items'][hexabaseState.datastoreIds['案件与信OA']] = [];
            for (let i = 0; i < projectCredit.length; i++) {
              if (projectCredit[i].entryFlag && projectCredit[i].id === undefined) {
                // 入力フラグが立っていてidがなければ新規追加
                const projectCreditItem = {
                  action_id: 'register',
                  operation: 1,
                  item: {
                    display_order: projectCredit[i].display_order,
                    project_service_OA_id: this.projectServiceOAItemId,
                    // ※審査結果はoption_idをセット
                    check_status: projectCredit[i].check_status_id,
                    approval_monthly_lease_fee: projectCredit[i].approval_monthly_lease_fee
                      ? projectCredit[i].approval_monthly_lease_fee
                      : 0,
                    approval_contract_month: projectCredit[i].approval_contract_month
                      ? projectCredit[i].approval_contract_month
                      : 0,
                    approval_number: projectCredit[i].approval_number,
                    credit_product_id: projectCredit[i].credit_product_id,
                    // 以下ダイアログ入力情報
                    quantity: projectCredit[i].quantity ? projectCredit[i].quantity : 0,
                    monthly_lease_fee: projectCredit[i].monthly_lease_fee
                      ? projectCredit[i].monthly_lease_fee
                      : 0,
                    contract_month: projectCredit[i].contract_month
                      ? projectCredit[i].contract_month
                      : 0,
                    remaining_lease_fee: projectCredit[i].remaining_lease_fee
                      ? projectCredit[i].remaining_lease_fee
                      : 0,
                    acceptance_plan_date: projectCredit[i].acceptance_plan_date,
                    comment: projectCredit[i].comment
                  }
                };
                this.registData['related_ds_items'][hexabaseState.datastoreIds['案件与信OA']].push(
                  projectCreditItem
                );
              } else if (projectCredit[i].id !== undefined) {
                // idがあれば更新
                const projectCreditItem = {
                  action_id: 'update',
                  operation: 2,
                  rev_no: Number(projectCredit[i].rev_no),
                  i_id: projectCredit[i].i_id,
                  item: {
                    display_order: projectCredit[i].display_order,
                    // ※審査結果はoption_idをセット
                    check_status: projectCredit[i].check_status_id,
                    approval_monthly_lease_fee: projectCredit[i].approval_monthly_lease_fee
                      ? projectCredit[i].approval_monthly_lease_fee
                      : 0,
                    approval_contract_month: projectCredit[i].approval_contract_month
                      ? projectCredit[i].approval_contract_month
                      : 0,
                    approval_number: projectCredit[i].approval_number,
                    credit_product_id: projectCredit[i].credit_product_id,
                    // 以下ダイアログ入力情報
                    quantity: projectCredit[i].quantity ? projectCredit[i].quantity : 0,
                    monthly_lease_fee: projectCredit[i].monthly_lease_fee
                      ? projectCredit[i].monthly_lease_fee
                      : 0,
                    contract_month: projectCredit[i].contract_month
                      ? projectCredit[i].contract_month
                      : 0,
                    remaining_lease_fee: projectCredit[i].remaining_lease_fee
                      ? projectCredit[i].remaining_lease_fee
                      : 0,
                    acceptance_plan_date: projectCredit[i].acceptance_plan_date,
                    comment: projectCredit[i].comment
                  }
                };
                this.registData['related_ds_items'][hexabaseState.datastoreIds['案件与信OA']].push(
                  projectCreditItem
                );
              }
            }
            // 削除情報の追加
            for (const deleteItem of this.registProjectCreditDeleteData) {
              this.registData['related_ds_items'][hexabaseState.datastoreIds['案件与信OA']].push(
                deleteItem
              );
            }
            this.registData.action_id = 'project_service_OA_valid_update';
            this.execAllowActions.push(projectServiceOa.status_actions[0]);
            const buttonType = 'project_service_OA_valid_update';
            await this.matter.estimateExecStatusAction(
              this.registData,
              this.projectId,
              this.projectServiceDsId,
              hexabaseState.datastoreIds['案件与信OA'],
              this.matterInfomationRegisterData.relatedItems.projectServiceOA.i_id,
              this.execAllowActions,
              this.execAllowActionsByDetail,
              Number(projectServiceOa.rev_no),
              buttonType
            );
            request.related_ds_items[this.projectServiceDsId][0].rev_no += 1;
          }

          const response =
            (this.buttonCrudType !== '4')
              ? await this.matter.execStatusAction(
                  request,
                  this.projectId,
                  this.mainDsId,
                  '',
                  this.matterItemId,
                  this.execAllowActions,
                  this.execAllowActionsByDetail,
                  Number(this.matterData.rev_no),
                  this.selectAction
                )
              : await this.matter.registerLinkedItems(this.projectId, this.mainDsId, request);

          // モーダル内のメッセージ変更
          this.registerText = response.text || this.registerText;

          if (this.buttonCrudType === '4') {
            this.registerText = `「${this.buttonActionName}」を実行しました`;
            this.matter.apiErrorHandle('CREATEITEM', response);
            this.buttons.splice(0);
            this.buttons.push({
              id: 1,
              type: 'routing',
              color: 'primary',
              value: '詳細画面へ',
              route: `/matter/edit/${response.item_id}`
            });
          }

          if (this.buttonActionName === '削除する') {
            this.buttons.splice(0);
            this.buttons.push({ id: 1, type: 'back', color: 'primary', value: '前画面へ戻る' });
          }

          break;
        } catch (e) {
          console.log(e);
          this.registerText = 'エラーにより処理できませんでした';
          this.buttons.splice(0);
          this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
        } finally {
          this.setLoading(false);
          this.dialogStatus = true;
        }
        break;
      }
      default:
        break;
    }
  }

  private async createRequestData() {
    // 基本データの成形
    const item: any = {};
    Object.keys(this.matterInfomationRegisterData).forEach((displayId: string) => {
      if (this.matterInfomationRegisterData[displayId] !== '') {
        if (displayId !== 'relatedItems') {
          const field = Object.values(this.matterFields.action_fields).find(
            (field: any) => field.display_id === displayId
          );
          if (field !== undefined) {
            item[field.field_id] = this.matterInfomationRegisterData[displayId];
          }
        }
      }
    });

    // コピーアクションの場合は案件ID付与
    // 案件コピーしたユーザを「manager_id」に指定
    let autoNumber: GetAutoNumberResponse;
    if (this.buttonCrudType === '4') {
      autoNumber = await this.matter.getAutoNumber(
        this.projectId,
        this.mainDsId,
        'id',
        userState.getMatterBranchKey
          ? {
              branch_key: userState.getMatterBranchKey,
              zero_padding: 'true',
              digit: '5'
            }
          : {}
      );
      item.project_id = autoNumber.result.value;
      item.manager_id = userState.getUserEmployeeId;
      // 案件コピーしたユーザの会社名を設定
      const companyItem = this.findCompanyItem(item.manager_id);
      item.company_id = companyItem ? companyItem.i_id : '';
    }

    // 関連データの成形
    const relatedItems: { [key: string]: Array<any> } = {};
    const relatedItemDatas: any = this.matterInfomationRegisterData['relatedItems'];
    if (this.buttonCrudType === '4') {
      const dsKey = this.screenStructureType === '1' ? 'projectServiceOA' 
      : this.screenStructureType === '2' ? 'projectServiceFJapan'
      : 'projectServiceGeneral';
      const estimateDsId =
        this.screenStructureType === '1' ? 't_estimate_basic_infomation_OA'
          : this.screenStructureType === '2' ? 't_estimate_basic_infomation_fjapan'
          : 't_estimate_basic_infomation_general';
      if (relatedItemDatas[dsKey]['estimateInfomation']) {
        const activeEstimateInformation = relatedItemDatas[dsKey]['estimateInfomation'].filter(
          (v: { Status: string }) => v.Status !== '削除済'
        );
        if (activeEstimateInformation.length > 0) {
          const linkedItemResult: { [k: string]: any }[] = await Promise.all(
            activeEstimateInformation.map(async (item: { [k: string]: string }) => {
              const linkedResponse = await this.matter.getLinked(
                this.projectId,
                estimateDsId,
                item.i_id,
                hexabaseState.datastoreIds['構成表'],
                true
              );
              let response = [];
              response = linkedResponse.result.t_material.items.map((record: any) => {
                for (const [key, value] of Object.entries(record)) {
                  if (record.lookup_items && record.lookup_items[key]) {
                    record[key] = record.lookup_items[key].i_id;
                  }
                }
                delete record['lookup_items'];
                return record;
              });
              return { i_id: item.i_id, items: response };
            })
          );

          activeEstimateInformation.forEach((estimate: { [k: string]: any }) => {
            const find = linkedItemResult.find(data => data.i_id === estimate.i_id);
            if (find) {
              estimate.related_ds_items[hexabaseState.datastoreIds['構成表']] = find.items;
            }
          });
        }
      }
    }

    Object.keys(relatedItemDatas).forEach((dsName: string) => {
      switch (this.screenStructureType) {
        case '1': {
          if (dsName === 'projectServiceGeneral' || dsName === 'projectServiceFJapan') {
            return true;
          }
          break;
        }
        case '2': {
          // F-Japan以外のdsNameはスキップ
          if (dsName !== 'projectServiceFJapan') {
            return true;
          }
          break;
        }
        case '99': {
          if (dsName === 'projectServiceOA' || dsName === 'projectServiceFJapan') {
            return true;
          }
          break;
        }
      }

      const dsId = hexabaseState.datastoreIds[RelatedDatastoreNames[dsName]];
      const fields = this.relatedFields[dsName];
      const itemDatas = relatedItemDatas[dsName];

      const item: any = {};
      const relatedChildItems: any = {};
      const estimateRelatedChildItems: any = {};
      const estimateLinks: any = {};

      Object.keys(itemDatas).forEach(displayId => {
        const itemData = itemDatas[displayId];
        if (Array.isArray(itemData)) {
          const childDsId = hexabaseState.datastoreIds[RelatedDatastoreNames[displayId]];
          const fields = this.relatedFields[displayId];
          if (fields !== undefined) {
            Object.values(itemData.filter(v => v.Status !== '削除済')).forEach((values: any) => {
              const childItem: any = {};
              Object.keys(values).forEach((displayId: any) => {
                const field = Object.values(fields.action_fields).find(
                  (field: any) => field.display_id === displayId
                );
                if (field !== undefined) {
                  if (typeof values[displayId] === 'object') {
                    if (displayId === 'leasing_company_id') {
                      childItem[field.display_id] = values[displayId].i_id;
                    }
                  } else {
                    if (displayId === 'project_id' && this.buttonCrudType === '4') {
                      childItem[field.display_id] = autoNumber.result.value;
                    } else {
                      childItem[field.display_id] = values[displayId];
                    }
                  }
                }
              });
              if (Object.keys(childItem).length > 0) {
                if (relatedChildItems[childDsId] === undefined) {
                  relatedChildItems[childDsId] = [];
                }

                const relatedChildItem: any = {
                  link_to_parent: true,
                  item: childItem
                };
                if (this.selectAction === 'project_basic_info_estimate_create_delete') {
                  relatedChildItem['i_id'] = values.i_id;
                  relatedChildItem['operation'] = 12;
                } else if (this.buttonCrudType === '4') {
                  relatedChildItem['operation'] = 1;
                } else if (values.i_id) {
                  relatedChildItem['i_id'] = values.i_id;
                  relatedChildItem['rev_no'] = Number(values.rev_no);
                  relatedChildItem['operation'] = Number(this.buttonCrudType);
                } else {
                  relatedChildItem['operation'] = 1;
                }

                relatedChildItems[childDsId].push(relatedChildItem);
              }
            });
          }

          if (this.buttonCrudType === '4') {
            if (displayId === 'estimateInfomation') {
              const dsKey =
                this.screenStructureType === '1' ? 'estimateBasicInfomationOA'
                  : this.screenStructureType === '2' ? 'estimateBasicInfomationFJapan'
                  : 'estimateBasicInfomationGeneral';
              const fields = this.copyRelatedFields[dsKey];
              const targetDsList: { [key: string]: string } = {};
              for (const [key, value] of Object.entries(CopyDSNames)) {
                targetDsList[key] = hexabaseState.datastoreIds[value];
              }
              if (fields !== undefined) {
                estimateRelatedChildItems[targetDsList[dsKey]] = [];
                Object.values(itemData.filter(v => v.Status !== '削除済')).forEach(
                  (values: any) => {
                    const estimateChildItem: any = {};
                    Object.keys(values).forEach((displayId: any) => {
                      const field = Object.values(fields.action_fields).find(
                        (field: any) => field.display_id === displayId
                      );
                      if (field !== undefined) {
                        if (displayId === 'project_id') {
                          estimateChildItem[field.display_id] = autoNumber.result.value;
                        } else {
                          if (displayId !== 'Status' && displayId !== 'id') {
                            switch (field.dataType) {
                              case 'select':
                              case 'radio': {
                                const findOption = field.options.find(
                                  (option: { [k: string]: string }) =>
                                    option.value === values[displayId]
                                );
                                estimateChildItem[field.display_id] =
                                  findOption !== undefined ? findOption.option_id : '';
                                break;
                              }
                              case 'file': {
                                break;
                              }
                              default: {
                                estimateChildItem[field.display_id] = values[displayId];
                                break;
                              }
                            }
                          }
                        }
                      }
                      if (displayId === 'related_ds_items') {
                        for (const [defineName, copyDsId] of Object.entries(targetDsList)) {
                          const fields = this.copyRelatedFields[defineName];
                          if (fields !== undefined) {
                            estimateLinks[copyDsId] = [];
                            const items = values[displayId][copyDsId];
                            if (items) {
                              Object.values(items).forEach((item: any) => {
                                const childItem: any = {};
                                Object.keys(item).forEach((displayId: any) => {
                                  const field = Object.values(fields.action_fields).find(
                                    (field: any) => field.display_id === displayId
                                  );
                                  if (field !== undefined) {
                                    if (displayId === 'project_id') {
                                      childItem[field.display_id] = autoNumber.result.value;
                                    } else {
                                      if (displayId !== 'Status' && displayId !== 'id') {
                                        switch (field.dataType) {
                                          case 'select':
                                          case 'radio': {
                                            const findOption = field.options.find(
                                              (option: { [k: string]: string }) =>
                                                option.value === item[displayId]
                                            );
                                            childItem[field.display_id] =
                                              findOption !== undefined ? findOption.option_id : '';
                                            break;
                                          }
                                          case 'file': {
                                            break;
                                          }
                                          default: {
                                            childItem[field.display_id] = item[displayId];
                                            break;
                                          }
                                        }
                                      }
                                    }
                                  }
                                });
                                // DB側で入力必須になっている為、万が一存在しない場合は「見積登録」に従い空文字を入れ回避
                                childItem['estimate_id'] = childItem['estimate_id'] || ' ';
                                estimateLinks[copyDsId].push({
                                  operation: 1,
                                  item: childItem,
                                  link_to_parent: true,
                                  action_id: fields.action.action_id
                                });
                              });
                            }
                          }
                        }
                      }
                    });
                    // アイテムが存在しないテーブルはインサート対象外
                    const excludeDsIds: string[] = [];
                    Object.entries(estimateLinks).forEach(([key, value], index) => {
                      if (Array.isArray(value) && value.length === 0) {
                        excludeDsIds.push(key);
                      }
                    });
                    excludeDsIds.forEach(dId => delete estimateLinks[dId]);
                    estimateRelatedChildItems[targetDsList[dsKey]].push({
                      operation: 1,
                      link_to_parent: true,
                      item: estimateChildItem,
                      related_ds_items: this.estimate.deepCopy(estimateLinks),
                      action_id: 'temporarily_save'
                    });
                  }
                );
              }
            }
          }
        } else {
          const field = Object.values(fields.action_fields).find(
            (field: any) => field.display_id === displayId
          );
          if (field !== undefined) {
            if (typeof itemData === 'object') {
              if (displayId === 'leasing_company_id' || displayId === 'final_estimate_id') {
                item[field.display_id] = itemData.i_id;
              }
            } else {
              if (displayId === 'project_id' && this.buttonCrudType === '4') {
                item[field.display_id] = autoNumber.result.value;
              } else if (displayId === 'credit_status' && this.buttonCrudType === '4') {
                // コピーの場合与信ステータスを「確認中」に戻す
                const checkingList: string[] = field.options
                  .map((option: any) => {
                    if (option.value === '確認中') {
                      return option.option_id;
                    }
                  })
                  .filter((value: string | undefined) => value);
                item[field.display_id] = checkingList[0];
              } else {
                item[field.display_id] = itemData;
              }
            }
          }
        }
      });

      if (Object.keys(item).length > 0 || Object.keys(relatedChildItems).length > 0) {
        const relatedItem: any = {
          link_to_parent: true
        };
        if (this.buttonCrudType === '4') {
          relatedItem['operation'] = 1;
        } else {
          relatedItem['operation'] = Number(this.buttonCrudType);
          relatedItem['i_id'] = itemDatas.i_id;
          relatedItem['rev_no'] = Number(itemDatas.rev_no);
        }
        if (relatedItems[dsId] === undefined) {
          relatedItems[dsId] = [];
        }

        if (Object.keys(item).length > 0) {
          relatedItem.item = item;
        }
        if (Object.keys(relatedChildItems).length > 0) {
          relatedItem.related_ds_items = relatedChildItems;
        }
        if (Object.keys(estimateRelatedChildItems).length > 0) {
          relatedItem.related_ds_items = {
            ...relatedItem.related_ds_items,
            ...estimateRelatedChildItems
          };
        }

        relatedItems[dsId].push(relatedItem);
      }
    });
    // 登録リクエスト
    const params: any = {
      item: item,
      return_item_result: true,
      ensure_transaction: true,
      rev_no: Number(this.matterData.rev_no)
    };
    if (this.buttonCrudType !== '4') {
      params['i_id'] = this.matterItemId;
    }
    if (Object.keys(relatedItems).length > 0) {
      params.related_ds_items = relatedItems;
    }
    return params;
  }

  private setLoading(bool: boolean) {
    this.$store.commit('hexabase/setIsLoading', bool);
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  async modifyFields(
    dbId: string,
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    execAction: ActionButtons,
    type: string,
    isDetail?: boolean
  ) {
    const inputFields = await this.matter
      .getFieldsByActionId(dbId, execAction.action_id)
      .then(data => {
        return data;
      });

    // if (isDetail !== undefined && isDetail){
    //   this.detailFieldSetting = inputFields;
    //   for (const index in data){
    //     const response = this.addInputRules(data[index] as Array<FieldChildrenProp>, inputFields.action_field_settings, type);
    //     data[index] = this.modifyInputAllow(response, inputFields.action_field_settings);
    //   }
    //   return data as Array<FieldChildrenProp[]>;
    // }

    data = this.addInputRules(
      data as Array<FieldChildrenProp>,
      inputFields.action_field_settings,
      type
    );
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting },
    type: string
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        const row = fieldSetting[field.field_id];
        if (row.update) {
          field.props! = { ...field.props!, ...{ isDisabled: false, isReadonly: false } };
        }
        if (row.update && field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  /**
   * 親コンポーネントに入力値を通知する
   * @module inputOperation
   * @param data - 名前と入力値
   * @param index - 複数行項目変更時の行番号
   */
  async inputOperation(data: any, index?: number) {
    if (index === undefined && data.name.indexOf('.') === -1) {
      if (data.name === 'customer_id') {
        // 顧客
        const item = this.masterData.m_customer.body.find((v: any) => v.i_id === data.value);
        this.customerItemId = item!.i_id;
        this.masterSelectCustomerSelected = { i_id: data.value };
        this.$set(this.matterInfomationRegisterData, 'telephone_number', item!['telephone_number']);
      }
      if (data.name === 'department_billing_address_id') {
        // 顧客部署（申込元・請求先）
        const index = this.masterSelectCustomerDepartmentData.findIndex(
          (item: any) => item.i_id === data.value
        );
        const str = this.masterSelectCustomerDepartmentData[index].payment_infomation;
        const selectedIndex = this.customerDepartmentPaymentInfomationItem.options.findIndex(
          (item: any) => item.text === str
        );
        this.$set(
          this.matterInfomationRegisterData,
          'billing_payment_information',
          this.customerDepartmentPaymentInfomationItem.options[selectedIndex].value
        );
        this.basicFieldsData.find(v => v.display_id === 'billing_payment_information')![
          'props'
        ]!.value = this.customerDepartmentPaymentInfomationItem.options[selectedIndex].value;
      }
      if (data.name === 'department_delivery_destination_id') {
        // 顧客部署（設置先・納入先）
        const index = this.masterSelectCustomerDepartmentData.findIndex(
          (item: any) => item.i_id === data.value
        );
        const customerDepartment = this.masterSelectCustomerDepartmentData[index];
        let str = customerDepartment.prefectures ? String(customerDepartment.prefectures) : '';
        str += customerDepartment.municipalities ? String(customerDepartment.municipalities) : '';
        str += customerDepartment.machimura_street_address
          ? String(customerDepartment.machimura_street_address)
          : '';
        str += customerDepartment.building_name ? String(customerDepartment.building_name) : '';
        this.$set(this.matterInfomationRegisterData, 'installation_address', str);
        this.basicFieldsData.find(v => v.display_id === 'installation_address')![
          'props'
        ]!.value = str;
      }
      if (data.name === 'service_type_id') {
        // サービス種別
        const item = this.masterSelectServiceTypeData.find((v: any) => v.i_id === data.value);
        const screenStructureType = item!['screen_structure_type'];
        const serviceType = item!['service_type'];
        this.screenStructureType = screenStructureType;
        this.serviceType = serviceType;
        this.onChangeScreenStructureType();
      }
      const index = this.basicFieldsData.findIndex(v => v.display_id === data.name);
      this.$set(this.matterInfomationRegisterData, data.name, data.value);
      this.$set(this.basicFieldsData[index].props!, 'value', data.value);
    } else {
      // タブパネル内コンテンツ
      const dataNames = data.name.split('.');
      if (dataNames.length == 2) {
        // 子
        const [targetTranConst, targetColumn] = Object.values(dataNames);
        let targetTran = targetTranConst;
        if (targetTranConst === 'projectService') {
          switch (this.screenStructureType) {
            case '1': {
              targetTran = 'projectServiceOA';
              break;
            }
            case '2': {
              targetTran = 'projectServiceFJapan';
              break;
            }
            case '99': {
              targetTran = 'projectServiceGeneral';
              break;
            }
            default:
              break;
          }
        }
        let baseObj = this.matterInfomationRegisterData.relatedItems[targetTran];
        if (index !== undefined) {
          if (baseObj[index] === undefined) {
            baseObj[index] = {};
          }
          baseObj[index][targetColumn] = data.value;
        } else {
          if (baseObj === undefined) {
            baseObj = {};
          }
          switch (targetColumn) {
            case 'leasing_company_id':
              baseObj[targetColumn] = { i_id: data.value };
              break;
            case 'true_status':
              baseObj[targetColumn] = data.value.value;
              break;
            case 'final_estimate_id': {
              const estimateItemId = data.value;
              baseObj[targetColumn] = { i_id: estimateItemId };
              const estimateItem = this.estimateItems.find(
                (estimateItem: any) => estimateItem.i_id === estimateItemId
              );
              Object.keys(estimateItem).forEach((key: string) => {
                if (key !== 'i_id') {
                  if (key === 'estimated_tax_excluded') {
                    baseObj['estimated_amount'] = estimateItem[key];
                  } else if (key === 'total_tax_included') {
                    baseObj['total_fee'] = estimateItem[key];
                  } else if (key === 'leasing_company_id') {
                    const leasingCompany = this.masterData.m_leasing_company.body.find(
                      (leasingCompany: any) => leasingCompany.i_id === estimateItem[key]
                    );
                    if (leasingCompany) {
                      baseObj['leasingCompanyName'] = leasingCompany.leasing_company;
                      baseObj['leasingCompanyPhoneNumber'] = leasingCompany.telephone_number;
                      // 本信タブにも反映
                      this.updateMainCreditLeasingCompany(leasingCompany.i_id);
                    }
                  } else {
                    // 見積データのリビジョン番号はコピーしない
                    if (key !== 'rev_no') {
                      baseObj[key] = estimateItem[key];
                    }
                  }
                }
              });
              break;
            }
            case 'total_sales_amount':
            case 'discount_amount':
              baseObj[targetColumn] = Number(data.value);
              this.calcEstimateAmount(baseObj);
              this.calcTax(baseObj);
              this.calcTotalAmount(baseObj);
              break;
            case 'sales_tax_rate':
              baseObj[targetColumn] = Number(data.value);
              this.calcTax(baseObj);
              this.calcTotalAmount(baseObj);
              break;
            default:
              baseObj[targetColumn] = data.value;
              break;
          }
        }
      }
    }
    this.setTabItems();
  }

  private updateMainCreditLeasingCompany(leasingCompanyItemId: string) {
    for (const tabItem of this.matterTabItems) {
      if (tabItem.title === '本信') {
        this.$set(tabItem.mainCreditStatusData, 'leasingCompany', leasingCompanyItemId);
      }
    }
    this.$set(
      this.matterInfomationRegisterData.relatedItems.projectServiceOA,
      'leasing_company_id',
      { i_id: leasingCompanyItemId }
    );
  }

  private tabChildrenEventRelay(response: any) {
    switch (response.action) {
      case 'inputOperation': {
        this.inputOperation(response.data, response.index);
        break;
      }
      case 'inputFiles': {
        this.setInputFiles(response.files);
        break;
      }
      case 'fileUpload': {
        this.fileUpload();
        break;
      }
      case 'listAction': {
        this.listAction(response.input);
        break;
      }
      case 'buttonAction': {
        if (this.selectAction !== undefined && this.selectAction !== '') {
          this.redirectTargetParam = { name: 'EstimateRegister' };
          this.isExecDialog = true;
        } else {
          this.redirectTo({ name: 'EstimateRegister' });
        }
        break;
      }
      case 'clickRowOpratipon': {
        if (this.selectAction !== undefined && this.selectAction !== '') {
          this.redirectTargetParam = {
            name: 'EstimateEdit',
            params: { datastoreId: this.estimateDsId, id: response.data.i_id }
          };
          this.isExecDialog = true;
        } else {
          this.redirectTo({
            name: 'EstimateEdit',
            params: { datastoreId: this.estimateDsId, id: response.data.i_id }
          });
        }
        break;
      }
      case 'addRow': {
        this.matterInfomationRegisterData.relatedItems.projectServiceOA.advanceCreditInformation[
          response.index
        ] = response.data;
        break;
      }
      case 'catchFileForm': {
        let projectService: any = undefined;
        switch (this.screenStructureType) {
          case '1': {
            projectService = this.matterInfomationRegisterData.relatedItems.projectServiceOA;
            break;
          }
          case '2': {
            projectService = this.matterInfomationRegisterData.relatedItems.projectServiceFJapan;
            break;
          }
          case '99': {
            projectService = this.matterInfomationRegisterData.relatedItems.projectServiceGeneral;
            break;
          }
          default:
            break;
        }
        const targetIndex = projectService.estimateInfomation.findIndex(
          (v: { i_id: string }) => v.i_id === response.event.itemId
        );
        projectService.estimateInfomation[targetIndex] = {
          ...projectService.estimateInfomation[targetIndex],
          ...response.event.item
        };
        // 更新後のrev_noを反映
        projectService.estimateInfomation[targetIndex].rev_no = response.event.revNumber;
        this.setTabItems();
        break;
      }

      case 'creditTab': {
        // 事前与信タブ内処理
        const tabItem = this.matterTabItems.find((item: any) => {
          if (item.title === '事前与信') {
            return item;
          }
        });
        if (tabItem !== undefined) {
          switch (response.eventName) {
            case 'inputTableData': {
              // 事前与信一覧テーブル内データ入力イベント
              switch (response.inputName) {
                case 'approval_monthly_lease_fee':
                case 'approval_contract_month':
                case 'approval_number': {
                  // 承認金額、承認期間、承認番号
                  const targetObj = this.matterInfomationRegisterData.relatedItems.projectServiceOA
                    .projectCredit[response.itemIndex];
                  targetObj[response.inputName] = response.inputValue;
                  targetObj.entryFlag = true;
                  break;
                }
                case 'check_status': {
                  // 審査結果
                  const targetObj = this.matterInfomationRegisterData.relatedItems.projectServiceOA
                    .projectCredit[response.itemIndex];
                  // 審査結果（select）の場合
                  // option_idを格納しているcheck_status_idにセット
                  targetObj['check_status_id'] = response.inputValue.value;
                  targetObj.entryFlag = true;
                  break;
                }
              }
              break;
            }
            case 'clickTableButton': {
              // 事前与信一覧テーブル内ボタン押下イベント
              switch (response.buttonName) {
                case 'deleteButton': {
                  // 削除ボタン押下
                  const baseObj = this.matterInfomationRegisterData.relatedItems.projectServiceOA
                    .projectCredit;
                  // 案件与信一覧の削除用データ作成（既存の登録済データのみ対象）
                  if (baseObj.length !== 0) {
                    if (baseObj[response.itemIndex].i_id !== undefined) {
                      // 論理削除情報
                      this.registProjectCreditDeleteData.push({
                        operation: 2,
                        action_id: 'project_credit_OA_valid_delete',
                        rev_no: Number(baseObj[response.itemIndex].rev_no),
                        i_id: baseObj[response.itemIndex].i_id
                      });
                      // リンク削除情報
                      this.registProjectCreditDeleteData.push({
                        operation: 12,
                        rev_no: Number(baseObj[response.itemIndex].rev_no),
                        i_id: baseObj[response.itemIndex].i_id
                      });
                    }
                    // 対象表示データを削除
                    baseObj.splice(response.itemIndex, 1);
                    for (const index in baseObj) {
                      // display_orderを採番
                      baseObj[index].display_order = Number(index) + 1;
                    }
                  }
                  this.setTabItems();
                  break;
                }
                case 'selectButtonIndex': {
                  // 検索ボタン押下および与信商品マスタ選択
                  if (response.selectData !== undefined) {
                    const targetObj = this.matterInfomationRegisterData.relatedItems
                      .projectServiceOA.projectCredit[response.selectRowData.itemIndex];
                    // 選択された与信商品マスタ情報をセット
                    targetObj.credit_product_id = response.selectData.i_id;
                    targetObj.leasing_company = response.selectData.leasing_company_id;
                    targetObj.product_classification = response.selectData.product_classification;
                    targetObj.prodact_name = response.selectData.prodact_name;
                    // 入力フラグを立てる
                    targetObj.entryFlag = true;
                    this.setTabItems();
                  }
                  break;
                }
                case 'applyButton': {
                  // 申込情報ボタン押下
                  // 申込情報ダイアログ情報のセット
                  tabItem.applyDialogTitle = '申込情報';
                  if (this.buttonActionName === '編集する') {
                    // 編集表示（buttonCrudTypeで判定できないため名前で判定）
                    tabItem.applyDialogItems = this.getHeaderFields(
                      JSON.parse(JSON.stringify(entryItemForms))
                    );
                    tabItem.applyDialogReadonly = false;
                  } else {
                    // 参照表示
                    tabItem.applyDialogItems = this.getHeaderFields(
                      JSON.parse(JSON.stringify(readonlyItemForms))
                    );
                    tabItem.applyDialogReadonly = true;
                  }
                  // 選択行の値（responseから取得）を初期値としてセット
                  const initialData = {
                    0: response.record.leasing_company ? response.record.leasing_company : '',
                    1: response.record.product_classification
                      ? response.record.product_classification
                      : '',
                    2: response.record.prodact_name ? response.record.prodact_name : '',
                    3: response.record.quantity ? response.record.quantity : 0,
                    4: response.record.monthly_lease_fee ? response.record.monthly_lease_fee : 0,
                    5: response.record.contract_month ? response.record.contract_month : 0,
                    6: response.record.remaining_lease_fee ? response.record.remaining_lease_fee : 0,
                    7: response.record.acceptance_plan_date
                      ? response.record.acceptance_plan_date
                      : null,
                    8: response.record.comment ? response.record.comment : ''
                  };
                  this.getHeaderData(initialData, tabItem.applyDialogItems);

                  // ダイアログ入力値の一時格納領域としてresponseを複製
                  this.applyDialogEntryItems = this.matter.deepCopy(response);

                  tabItem.dialogControl.register = true;
                  break;
                }
              }
              break;
            }
            case 'clickItemAdditionButton': {
              // 事前与信一覧項目追加ボタン押下
              const baseObj = this.matterInfomationRegisterData.relatedItems.projectServiceOA
                .projectCredit;
              baseObj[baseObj.length] = Object.assign(JSON.parse(JSON.stringify(DefaultListData)), {
                display_order: baseObj.length + 1
              });
              this.setTabItems();
              break;
            }
            case 'catchDialogInput': {
              // 申込情報ダイアログ内データ入力
              const entryItem = tabItem.applyDialogItems.datas.find((item: any) => {
                if (item.display_id === response.name) {
                  return item;
                }
              });
              if (response.value !== undefined) {
                // ※入力値をvalueに設定することでValidationが機能する
                entryItem.props.value = response.value;
              }

              if (this.applyDialogEntryItems) {
                // 一時格納領域にセット
                this.applyDialogEntryItems.record[response.name] = response.value;
              }
              break;
            }
            case 'applyDialogClose': {
              // 申込情報ダイアログキャンセルボタン押下
              // ダイアログを閉じる際に各項目の値を初期化(※これをやらないと表示がおかしくなる)
              tabItem.applyDialogItems = {};
              tabItem.dialogControl.register = false;
              break;
            }
            case 'applyDialogEntry': {
              // 申込情報ダイアログ設定ボタン押下
              // 一時格納領域から正式な領域に反映
              const targetObj = this.matterInfomationRegisterData.relatedItems.projectServiceOA
                .projectCredit[this.applyDialogEntryItems.itemIndex];

              targetObj.quantity = this.applyDialogEntryItems.record.quantity;
              targetObj.monthly_lease_fee = this.applyDialogEntryItems.record.monthly_lease_fee;
              targetObj.contract_month = this.applyDialogEntryItems.record.contract_month;
              targetObj.remaining_lease_fee = this.applyDialogEntryItems.record.remaining_lease_fee;
              targetObj.acceptance_plan_date = this.applyDialogEntryItems.record.acceptance_plan_date;
              targetObj.comment = this.applyDialogEntryItems.record.comment;
              // 入力フラグを立てる
              targetObj.entryFlag = true;

              // ダイアログを閉じる際に各項目の値を初期化
              tabItem.applyDialogItems = {};
              tabItem.dialogControl.register = false;
              break;
            }
          }
        }
        break;
      }

      case 'sendTab': {
        // 送信タブ内処理
        const tabItem = this.matterTabItems.find((item: any) => {
          if (item.title === '送信') {
            return item;
          }
        });
        if (tabItem !== undefined) {
          switch (response.eventName) {
            case 'getItemData': {
              tabItem.sendMailText.items.find((item: any) => {
                if (item.name === 'mail_text') {
                  item.value = appState.options['メールテンプレート']['案件詳細'].mail_template;
                  this.mailTextBackUp = item.value;
                }
              });

              const attachedFileData: any = JSON.parse(
                JSON.stringify(
                  this.masterData['m_form'].body.filter((data: any) => {
                    if (data.use_scene === '添付ファイル') {
                      return data;
                    }
                  })
                )
              );

              tabItem.projectServiceDsId= this.projectServiceDsId;
              tabItem.fileSelect.items = attachedFileData;
              if (this.screenStructureType === '1') {
                this.sendTargetService = this.projectServiceOa;
                tabItem.sendTargetFile.sendFileItemId = this.matterInfomationRegisterData.relatedItems.projectServiceOA.i_id;
              }
              if (this.screenStructureType === '2') {
                this.sendTargetService = this.projectServiceFJapan;
                tabItem.sendTargetFile.sendFileItemId = this.matterInfomationRegisterData.relatedItems.projectServiceFJapan.i_id;
              }
              if (this.screenStructureType === '99') {
                this.sendTargetService = this.projectServiceGeneral;
                tabItem.sendTargetFile.sendFileItemId = this.matterInfomationRegisterData.relatedItems.projectServiceGeneral.i_id;
              }

              this.sendTargetService.field_values.find((v: any) => {
                if (v.field_id === 'send_file') {
                  if (v.value) {
                    for (let i = 0; i < v.value.length; i++) {
                      this.$set(tabItem.sendTargetFile.items, i, v.value[i]);
                    }
                  }
                }
              }
              );
              break;
            }
            case 'formSelectDialogOpenButton': {
              tabItem.dialogControl = true;
              break;
            }
            case 'catchFileForm': {
              if (response.event.itemData.length !== 0) {
                tabItem.sendTargetFile.items = [];
                for (let i = 0; i < response.event.itemData.length; i++) {
                  this.$set(tabItem.sendTargetFile.items, i, response.event.itemData[i]);
                }
              } else {
                tabItem.sendTargetFile.items = [];
              }
              break;
            }
            case 'inputMailAddress': {
              tabItem.sendTargetMail.items[response.index].value = response.data.value;
              // 送信先メールアドレス
              if (!this.fileSendParams['to']) {
                this.fileSendParams['to'] = [];
                this.fileSendParams['to'][response.index] = {};
                this.fileSendParams['to'][response.index]['email'] = response.data.value;
              } else {
                this.fileSendParams['to'][response.index] = {};
                this.fileSendParams['to'][response.index]['email'] = response.data.value;
                if (this.fileSendParams['to'][response.index]['email'] === '') {
                  delete this.fileSendParams['to'][response.index]
                }
              }
              break;
            }
            case 'inputMailTitle': {
              // 件名
              tabItem.mailTitle.value = response.data.value;
              this.fileSendParams['subject'] = response.data.value;
              break;
            }
            case 'inputMailText': {
              // メール本文
              this.fileSendParams['content'] = response.data.value;
              // 入力内容退避
              this.mailTextBackUp = this.fileSendParams['content'];
              break;
            }
            case 'checkBoxOperatipon': {
              if (response.data.checkStatus === false && this.fileSendParams['attachmentFiles']) {
                const attachmentFiles = this.fileSendParams['attachmentFiles'].filter((item: any) => {
                  return (item.i_id !== response.data.i_id);
                });
                this.fileSendParams['attachmentFiles'] = attachmentFiles;
              }
              if (response.data.checkStatus === true) {
                if (this.fileSendParams['attachmentFiles']) {
                  const iIds = [];
                  for (let i = 0; i < this.fileSendParams['attachmentFiles'].length; i++) {
                    iIds.push(this.fileSendParams['attachmentFiles'][i]['i_id']);
                  }
                  if (iIds.includes(response.data.i_id)) {
                    this.fileSendParams['attachmentFiles'].find((item: any) => {
                      if (item.i_id === response.data.i_id) {
                        return;
                      }
                    });
                  } else {
                    this.fileSendParams['attachmentFiles'].push(response.data);
                  }
                } else if (!this.fileSendParams['attachmentFiles']) {
                  this.fileSendParams['attachmentFiles'] = [];
                  this.fileSendParams['attachmentFiles'].push(response.data);
                }
              }
              break;
            }
            case 'mailPreview': {
              // 案件詳細の項目内容を取得
              let basicFields: any = [];
              basicFields = this.basicFieldsData.map((item: any) => {
                return item.props;
              });
              const outputDatas = basicFields.map((item: any) => {
                if (item.outPutData) {
                  return item.outPutData;
                }
              }).filter(Boolean);

              this.matterOutputDatas = [];
              for (let i = 0; i < outputDatas.length; i++) {
                for (let index = 0; index < outputDatas[i].length; index++) {
                  this.matterOutputDatas.push(outputDatas[i][index]);
                }
              }

              // メール本文の文字列を取得し、別の変数に格納する
              if (!this.fileSendParams['content']) {
                this.fileSendParams['content'] = appState.options['メールテンプレート']['案件詳細'].mail_template;
              }
              const beforePreviewText = this.fileSendParams['content'];
              const variables = beforePreviewText.match(/%.*?%/g);
              if (variables) {
                for (let i = 0; i < variables.length; i++) {
                  const property = variables[i].match(/%(.+)%/)[1];
                  if (property === '送信対象ファイル') {
                    if (tabItem.sendTargetFile.items) {
                      this.sendTargetFileNames = '';
                      for (let i = 0; i < tabItem.sendTargetFile.items.length; i++) {
                        if (i === tabItem.sendTargetFile.items.length - 1) {
                          this.sendTargetFileNames = this.sendTargetFileNames + tabItem.sendTargetFile.items[i].filename
                        } else {
                          this.sendTargetFileNames = this.sendTargetFileNames + tabItem.sendTargetFile.items[i].filename + '\n'
                        }
                      }
                      this.fileSendParams['content'] = this.fileSendParams['content'].replace(variables[i], this.sendTargetFileNames)
                    } else {
                      this.fileSendParams['content'] = this.fileSendParams['content'].replace(variables[i], '')
                    }
                  } else if (property === '添付ファイル') {
                    if (this.fileSendParams['attachmentFiles']) {
                      this.attachmentFileNames = '';
                      for (let i = 0; i < this.fileSendParams['attachmentFiles'].length; i++) {
                        if (i === this.fileSendParams['attachmentFiles'].length - 1) {
                          this.attachmentFileNames = this.attachmentFileNames + this.fileSendParams['attachmentFiles'][i].docurain_template_name
                        } else {
                          this.attachmentFileNames = this.attachmentFileNames + this.fileSendParams['attachmentFiles'][i].docurain_template_name + '\n'
                        }
                      }
                      this.fileSendParams['content'] = this.fileSendParams['content'].replace(variables[i], this.attachmentFileNames)
                    } else {
                      this.fileSendParams['content'] = this.fileSendParams['content'].replace(variables[i], '')
                    }
                  } else {
                    // 案件詳細の項目オブジェクトからpropertyの値を取得
                    this.previewValue = basicFields.find((item: any) => {
                      if (item.labelText === property) {
                        return item;
                      }
                    });
                    if (this.previewValue === undefined) {
                      this.previewValue = this.matterOutputDatas.find((item: any) => {
                      if (item.label === property) {
                        return item;
                      }
                    });
                    }
                    // メール本文に存在するvariables[i]の文字を、取得した値に置き換える
                    if (this.previewValue !== undefined) {
                      this.fileSendParams['content'] = this.fileSendParams['content'].replace(variables[i], this.previewValue.value)
                    } else {
                      this.fileSendParams['content'] = this.fileSendParams['content'].replace(variables[i], '#項目置換エラー#')
                    }
                  }
                }
              }
              // プレビューのinputエリアに置き換えた内容で表示
              previewDialog.mailPreviewText = this.fileSendParams['content'];
              // 置換漏れが無ければ「メール送信」ボタンのdisabledをfalseにする
              const previewTextCheck = previewDialog.mailPreviewText.match(/#項目置換エラー#.*?/g);
              if (!previewTextCheck) {
                previewDialog.isMailSendDisabled = false;
              }
              break;
            }
            case 'previewDialogClose': {
              // 退避したメール本文で内容を上書き
              this.fileSendParams['content'] = this.mailTextBackUp;
              previewDialog.isMailSendDisabled = true;
              break;
            }
            case 'sendMail': {
              if (!response.isAgree) {
                return;
              } else {
                this.$store.commit('hexabase/setIsLoading', true);
                this.fileSendParams['to'] = this.fileSendParams['to'].filter(Boolean);
                this.fileSendParams['from'] = {
                  "email": appState.options['ファイル送信']['案件詳細'].file_send_email
                };
                if (this.screenStructureType === '1') {
                  this.projectService = hexabaseState.datastoreIds['案件サービス別OA']
                }
                if (this.screenStructureType === '2') {
                  this.projectService = hexabaseState.datastoreIds['案件サービス別F-Japan']
                }
                if (this.screenStructureType === '99') {
                  this.projectService = hexabaseState.datastoreIds['案件サービス別汎用']
                }
                previewDialog.isPreviewDialog = false;

                // docurainから出力した口座振替依頼書の情報をペイロードにセット
                if (this.fileSendParams['attachmentFiles']) {
                  const formItem = this.fileSendParams['attachmentFiles'].find((item: any) => {
                    if (item.form_name === '口座振替依頼書') {
                      return item;
                    }
                  });
                  if (formItem) {
                    this.fileSendParams['attachmentFiles'] = this.fileSendParams['attachmentFiles'].map((item: any) => {
                      if (item.form_name !== '口座振替依頼書') {
                        return item;
                      }
                    }).filter(Boolean);
                    const customerItemDetail = this.customerItemDetail.field_values.find((item: any) => {
                      if (item.field_id === 'customer_id') {
                        return item;
                      }
                    });
                    this.matter.getScriptVariable(this.projectId, 'CUSTOMER_CODE_DELIMITER')
                    .then(response => {
                      const customerId = customerItemDetail.value.replace('-', response.value);
                      const payload = {
                        root_list: [
                          {
                            kouzahurikae: {
                              customer_id: customerId
                            }
                          }
                        ]
                      };
                      this.formoutput(
                        this.projectId,
                        this.mainDsId,
                        this.matterItemId,
                        'output',
                        'pdf',
                        formItem.i_id,
                        payload,
                        '口座振替依頼書'
                      ).then(response => {
                        this.fileSendParams['formFileId'] = response.fileId;
                        this.fileSendParams['formFileName'] = response.fileName + '.' + response.fileType;

                        this.sendMail(
                          this.projectId,
                          this.projectService,
                          tabItem.sendTargetFile.sendFileItemId,
                          'send_mail',
                          this.fileSendParams
                        ).then(response => {
                          this.$store.commit('hexabase/setIsLoading', false);
                          sendCompletedDialog.isSendDialog = true;
                        });
                      });
                    });
                  } else {
                    this.sendMail(
                      this.projectId,
                      this.projectService,
                      tabItem.sendTargetFile.sendFileItemId,
                      'send_mail',
                      this.fileSendParams
                    ).then(response => {
                      this.$store.commit('hexabase/setIsLoading', false);
                      sendCompletedDialog.isSendDialog = true;
                    });
                  }
                } else {
                  this.sendMail(
                    this.projectId,
                    this.projectService,
                    tabItem.sendTargetFile.sendFileItemId,
                    'send_mail',
                    this.fileSendParams
                  ).then(response => {
                    this.$store.commit('hexabase/setIsLoading', false);
                    sendCompletedDialog.isSendDialog = true;
                  });
                }
                tabItem.dialogControl = true;
              }
              break;
            }
          }
        }
        break;
      }

      case 'contractInfomationTab': {
        // 契約タブ内処理
        const tabItem = this.matterTabItems.find((item: any) => {
          if (item.title === '契約') {
            return item;
          }
        });
        if (tabItem !== undefined) {
          switch (response.eventName) {
            case 'nonContractFileUpload': {
              this.nonContractFileUpload();
              break;
            }
            case 'setNonContractInputFiles': {
              this.nonContractinputFiles = response.files;
              tabItem.nonContractinputFiles = this.nonContractinputFiles;
              break;
            }
            case 'nonContractListAction': {
              this.nonContractListAction(response);
              break;
            }
            case 'radioItemEvent': {
              tabItem.radioItem.selectView = response.value;
              switch (response.value) {
                case 1: {
                  this.getContractDataFlag = true;
                  this.getContractTabItemListUpdate();
                  break;
                }
                case 2: {
                  // 非電磁契約用ファイルマネージャーの初期化
                  this.nonContractinputFiles = [];
                  if (tabItem !== undefined) {
                    tabItem.nonContractinputFiles = this.nonContractinputFiles;
                    if (this.contractInfomationItems['field_values'] !== undefined) {
                      this.nonContractCurrentFiles =
                        this.contractInfomationItems['field_values']['non_electronic_contract_file']
                          .value !== null
                          ? this.contractInfomationItems['field_values'][
                              'non_electronic_contract_file'
                            ].value
                          : [];
                      tabItem.nonElectronicContractList = this.nonContractCurrentFiles;
                      this.nonContractFileCount = this.nonContractCurrentFiles.length;
                      this.nonContractFileRevNo = this.contractInfomationItems.rev_no;
                    }
                  }
                  break;
                }
              }
              break;
            }
            case 'detailDialogFileDownloadButton': {
              const downloadData = this.matter.getFileDownload(
                tabItem.downloadFileInformation.fileId,
                tabItem.downloadFileInformation.name,
                'application/pdf'
              );
              break;
            }
            case 'signatureDetailUpdate': {
              this.$store.commit('hexabase/setIsLoading', true);
              const updateFlag = tabItem.detailItems.datas.find((item: any) => {
                if (item.display_id === 'matter_status_update_flag') {
                  return item;
                }
              });
              this.signatureDetailUpdate(updateFlag.props.checkStatus.matter_status_update_flag);
              tabItem.dialogControl.detailConfirm = false;
              break;
            }
            case 'signatureDetailDialogClose': {
              tabItem.dialogControl.detailConfirm = false;
              break;
            }
            case 'signatureRequest': {
              // 署名依頼の実行
              this.getSignatureRequest();

              // 「否認」のアイテムの自動更新フラグをfalseに変更
              const repudiationItem = tabItem.documentManagementTable.body.map((item: any) => {
                if (item.document_status === '否認') {
                  return item;
                }
              });
              if (repudiationItem.length !== 0) {
                for (let i = 0; i < repudiationItem.length; i++) {
                  if (repudiationItem[i].matter_status_update_flag !== '') {
                    repudiationItem[i].matter_status_update_flag = '';
                    this.signatureDetailUpdate(repudiationItem[i].matter_status_update_flag, repudiationItem[i].i_id, repudiationItem[i].rev_no);
                  }
                }
              }
              break;
            }
            case 'documentManagementTableUpdate': {
              // 契約タブ内更新ボタン押下
              this.getContractDataFlag = true;
              this.getContractTabItemListUpdate();
              break;
            }
            case 'signatureDialogClose': {
              // 項目内容の初期化
              this.signatureDialogDataInitialization(tabItem);
              tabItem.dialogControl.register = false;
              break;
            }
            case 'sampleDownloadButton': {
              const downloadData = this.matter.getFileDownload(
                this.contractDocumentData.docurainTemplateFile,
                this.contractDocumentData.docurainTemplateName,
                'application/octet-stream'
              );
              break;
            }
            case 'selectContractTypeEvent': {
              const item = tabItem.selectContractTypeItems.selectData.options.find((item: any) => {
                if (item.i_id === response.value) {
                  return item;
                }
              });
              this.contractDocumentData.docurainTemplateFile = item.docurain_template_file;
              this.contractDocumentData.docurainTemplateName = item.docurain_template_name;
              this.contractDocumentData.dataReportId = item.data_report_id;
              tabItem.isDocurainTemplateDownloadButton = false;

              const backUpContractSendData = JSON.parse(JSON.stringify(this.contractSendData));
              this.contractSendData = JSON.parse(JSON.stringify(ContractSendData));
              this.contractSendData['application_id'] = hexabaseState.applicationId;
              this.contractSendData['company_datastore_id'] =
                hexabaseState.datastoreIds['企業マスタ'];
              this.contractSendData['signing_datastore_id'] =
                hexabaseState.datastoreIds['署名位置マスタ'];
              this.contractSendData['documents_datastore_id'] =
                hexabaseState.datastoreIds['文書管理'];
              this.contractSendData['post_nm'] = userState.userDepartmentName;
              this.contractSendData['name_nm'] = userState.userName;
              const companyIdItem = this.basicFieldsData.find((item: any) => {
                if (item.display_id === 'company_id') {
                  this.masterData.m_company.body.find((recode: any) => {
                    if (item.props.value !== null) {
                      if (item.props.value.i_id === recode.i_id) {
                        this.contractSendData['company_id'] = recode.id;
                        this.contractSendData['simwork_email'] = recode['simwork_email'];
                      }
                    }
                  });
                }
                if (item.display_id === 'project_id') {
                  this.contractSendData['project_id'] = item.props.value;
                }
              });
              this.contractSendData['complete_email'] = backUpContractSendData['complete_email'];
              this.contractSendData['agreement_end_date'] = backUpContractSendData['agreement_end_date'];
              this.contractSendData['agreement_start_date'] = backUpContractSendData['agreement_start_date'];
              this.contractSendData['conclusion_date'] = backUpContractSendData['conclusion_date'];
              this.contractSendData['contract_amount'] = backUpContractSendData['contract_amount'];
              this.contractSendData['long_storage'] = backUpContractSendData['long_storage'];
              this.contractSendData['document_name'] = backUpContractSendData['document_name'];
              this.contractSendData['post_nm'] = backUpContractSendData['post_nm'];
              this.contractSendData['name_nm'] = backUpContractSendData['name_nm'];
              this.contractSendData['matter_status_update_flag'] = backUpContractSendData['matter_status_update_flag'];

              tabItem.selectContractTypeItems.value = response.value;

              this.signingGroupData.find((recode: any) => {
                if (recode.text === item.form_name) {
                  this.contractSendData['signing_group_id'] = recode.value;
                }
              });

              const signingItems = this.masterData.m_signing.body.filter((item: any) => {
                if (item.signing_group_id === this.contractSendData['signing_group_id']) {
                  return item;
                }
              });

              tabItem.accessCode.isShowAccessCode = false;
              // お客様担当者側
              const partnerItem = signingItems.find((item: any) => {
                if (item.signing_kind == '相手先署名' && item.signing_type == '署名' ) {
                  return item;
                }
              })
              tabItem.partnerSignaturePositionItems = {};
              if (partnerItem !== undefined) {

                const customerItem = this.masterSelectCustomerData.find((item: any) => {
                  if (this.customerItemId === item.i_id ) {
                    return item;
                  }
                })

                tabItem.partnerSignaturePositionItems = this.getHeaderFields(
                  JSON.parse(JSON.stringify(partnerSignaturePositionItemForms))
                );
                const partnerSignaturePositionData = {
                  0: customerItem.customer_name ? customerItem.customer_name : '',
                  1: customerItem.manager ? customerItem.manager : '',
                  2: '',
                  3: ''
                };
                this.getHeaderData(
                  partnerSignaturePositionData,
                  tabItem.partnerSignaturePositionItems
                );
                this.contractSendData['organize_nm'] = customerItem.customer_name
                  ? customerItem.customer_name
                  : '';
                this.contractSendData['partner_signing_name_list'][0]['name'] = customerItem.manager
                  ? customerItem.manager
                  : '';

                tabItem.accessCode.isShowAccessCode = true;
                tabItem.dialogButtonType = false;

                for (const index in tabItem.partnerSignaturePositionItems.datas) {
                  tabItem.partnerSignaturePositionItems.datas[index].props.isReadonly = false;
                  tabItem.partnerSignaturePositionItems.datas[index].props.isDisabled = false;
                }
              }

              const ourItem = signingItems.find((item: any) => {
                if (item.signing_kind == '自社署名' && item.signing_type == '署名' ) {
                  return item;
                }
              })
              tabItem.ourSignaturePositionItems = {};
              if (ourItem !== undefined) {
                // 自社担当者側
                tabItem.ourSignaturePositionItems = this.getHeaderFields(
                  JSON.parse(JSON.stringify(ourSignaturePositionItemForms))
                );
                const ourSignaturePositionData = {
                  0: userState.userName,
                  1: userState.userEmail,
                  2: ''
                };
                this.getHeaderData(ourSignaturePositionData, tabItem.ourSignaturePositionItems);
                this.contractSendData['our_signing_name_list'][0]['name'] = userState.userName;
                this.contractSendData['our_signing_email_list'][0]['mail_address'] = userState.userEmail;

                for (const index in tabItem.ourSignaturePositionItems.datas) {
                  tabItem.ourSignaturePositionItems.datas[index].props.isReadonly = false;
                  tabItem.ourSignaturePositionItems.datas[index].props.isDisabled = false;
                }
              }

              break;
            }
            case 'catchDialogInput': {
              // 契約情報登録画面内の入力値反映
              let recode:any = {};
              if (response.panelName === 'accessCode') {
                recode = tabItem[response.panelName];
                if (response.value !== undefined) {
                  recode['access_code'] = response.value;
                }
              } else if (response.panelName === 'detailItems') {
                recode = tabItem.detailItems.datas.find((item: any) => {
                  if (item.display_id === 'matter_status_update_flag') {
                    return item;
                  }
                });
              } else {
                recode = tabItem[response.panelName].datas.find((item: any) => {
                  if (item.display_id === response.name) {
                    return item;
                  }
                });
                if (response.value !== undefined) {
                  recode.props.value = response.value;
                }
              }

              // 送信用パラメータの編集
              switch (recode.display_id) {
                case 'long_storage': {
                  recode.props.checkStatus.long_storage = response.long_storage;
                  if (response.long_storage === true) {
                    this.contractSendData[response.name] = 1;
                  } else {
                    this.contractSendData[response.name] = 2;
                  }
                  break;
                }
                case 'matter_status_update_flag': {
                  recode.props.checkStatus.matter_status_update_flag = response.matter_status_update_flag;
                  if (response.panelName === 'fileUploadItems') {
                    this.contractSendData[response.name] = response.matter_status_update_flag;
                  }
                  break;
                }
                case 'partner_signing_email_list':
                case 'our_signing_email_list': {
                  this.contractSendData[response.name][0]['mail_address'] = response.value;
                  break;
                }
                case 'partner_signing_name_list':
                case 'our_signing_name_list': {
                  this.contractSendData[response.name][0]['name'] = response.value;
                  break;
                }
                default: {
                  this.contractSendData[response.name] = response.value;
                  break;
                }
              }
              break;
            }
            case 'signatureRequestConfirmationOpen': {
              // 契約情報登録画面の送信確認画面
              tabItem.detailDialogTitle = '確認';
              tabItem.detailItems = {};
              tabItem.detailItems = this.getHeaderFields(
                JSON.parse(JSON.stringify(contractInfomationConfirmForms))
              );
              const contractInfomationDetailData = { 0: '', 1: '', 2: '', 3: '', 4: '', 5: '' };
              this.getHeaderData(contractInfomationDetailData, tabItem.detailItems);
              for (const indexA in tabItem.detailItems.datas) {
                if (tabItem.detailItems.datas[indexA].display_id === 'contractType') {
                  tabItem.detailItems.datas[indexA].props.selectData = tabItem.selectContractTypeItems.selectData;
                  tabItem.detailItems.datas[indexA].props.value = tabItem.selectContractTypeItems.value;
                  tabItem.detailItems.datas[indexA].show = true;
                }

                for (const indexB in tabItem.fileUploadItems.datas) {
                  if (
                    tabItem.detailItems.datas[indexA].display_id ===
                    tabItem.fileUploadItems.datas[indexB].display_id
                  ) {
                    switch (tabItem.detailItems.datas[indexA].display_id) {
                      case 'long_storage': {
                        if (tabItem.fileUploadItems.datas[indexB].props.checkStatus.long_storage !== true) {
                          tabItem.detailItems.datas[indexA].props.checkBoxs[0].default = false;
                        } else {
                          tabItem.detailItems.datas[indexA].props.checkBoxs[0].default = true;
                        }
                        break;
                      }
                      case 'matter_status_update_flag': {
                        if (tabItem.fileUploadItems.datas[indexB].props.checkStatus.matter_status_update_flag !== true) {
                          tabItem.detailItems.datas[indexA].props.checkBoxs[0].default = false;
                        } else {
                          tabItem.detailItems.datas[indexA].props.checkBoxs[0].default = true;
                        }
                        break;
                      }
                      default: {
                        tabItem.detailItems.datas[indexA].props.value = JSON.parse(
                          JSON.stringify(tabItem.fileUploadItems.datas[indexB].props.value)
                        );
                      }
                    }
                    tabItem.detailItems.datas[indexA].show = true;
                  }
                }

                if(tabItem.partnerSignaturePositionItems.datas !== undefined) {
                  for (const indexC in tabItem.partnerSignaturePositionItems.datas) {
                    if (tabItem.detailItems.datas[indexA].display_id === tabItem.partnerSignaturePositionItems.datas[indexC].display_id) {
                      tabItem.detailItems.datas[indexA].props.value = JSON.parse(
                        JSON.stringify(tabItem.partnerSignaturePositionItems.datas[indexC].props.value)
                      );
                      tabItem.detailItems.datas[indexA].show = true;
                    }
                  }

                  if (tabItem.detailItems.datas[indexA].display_id === 'access_code') {
                    tabItem.detailItems.datas[indexA].props.value = tabItem.accessCode['access_code'];
                    tabItem.detailItems.datas[indexA].show = true;
                  }
                }

                if(tabItem.ourSignaturePositionItems.datas !== undefined) {
                  for (const indexD in tabItem.ourSignaturePositionItems.datas) {
                    if (
                      tabItem.detailItems.datas[indexA].display_id ===
                      tabItem.ourSignaturePositionItems.datas[indexD].display_id
                    ) {
                      tabItem.detailItems.datas[indexA].props.value = JSON.parse(
                        JSON.stringify(tabItem.ourSignaturePositionItems.datas[indexD].props.value)
                      );
                    tabItem.detailItems.datas[indexA].show = true;
                    }
                  }
                }
                tabItem.detailItems.datas[indexA].props.isReadonly = true;
                tabItem.detailItems.datas[indexA].props.isDisabled = true;
              }
              tabItem.dialogControl.detailConfirm = true;
              break;
            }
            case 'signatureDialogOpenButton': {
              try {
                this.$store.commit('hexabase/setIsLoading', true);
                tabItem.dialogTitle = '契約情報登録画面';
                this.contractSendData = JSON.parse(JSON.stringify(ContractSendData));
                this.contractSendData['application_id'] = hexabaseState.applicationId;
                this.contractSendData['company_datastore_id'] =
                  hexabaseState.datastoreIds['企業マスタ'];
                this.contractSendData['signing_datastore_id'] =
                  hexabaseState.datastoreIds['署名位置マスタ'];
                this.contractSendData['documents_datastore_id'] =
                  hexabaseState.datastoreIds['文書管理'];

                // ファイルアップロード側
                tabItem.fileUploadItems = this.getHeaderFields(
                  JSON.parse(JSON.stringify(fileUploadItemForms))
                );
                const fileUploadData = {
                  0: '',
                  1: userState.userDepartmentName,
                  2: userState.userName,
                  3: ''
                };
                this.getHeaderData(fileUploadData, tabItem.fileUploadItems);
                this.contractSendData['post_nm'] = userState.userDepartmentName;
                this.contractSendData['name_nm'] = userState.userName;

                const companyIdItem = this.basicFieldsData.find((item: any) => {
                  if (item.display_id === 'company_id') {
                    this.masterData.m_company.body.find((recode: any) => {
                      if (item.props.value !== null) {
                        if (item.props.value.i_id === recode.i_id) {
                          this.contractSendData['company_id'] = recode.id;
                          this.contractSendData['simwork_email'] = recode['simwork_email'];
                        }
                      }
                    });
                  }
                  if (item.display_id === 'project_id') {
                    this.contractSendData['project_id'] = item.props.value;
                  }
                });
                tabItem.selectContractTypeItems.selectData.options = this.contractTemplateSelectData;
                tabItem.selectContractTypeItems.value = '';

                // 登録のため、isReadonly・isDisabledを解除
                for (const index in tabItem.fileUploadItems.datas) {
                  tabItem.fileUploadItems.datas[index].props.isReadonly = false;
                  tabItem.fileUploadItems.datas[index].props.isDisabled = false;
                }
                tabItem.dialogControl.register = true;

              } catch (errorMessage) {
                this.setError(errorMessage);
              } finally {
                this.$store.commit('hexabase/setIsLoading', false);
              }
              break;
            }
            case 'clickTableButton': {
              tabItem.dialogTitle = '契約情報詳細画面';
              switch (response.buttonName) {
                case 'download': {
                  this.contractInDocumentDownload(response);
                  break;
                }
                case 'detail': {
                  this.contractInformationDetailItemId = response.record.i_id;
                  tabItem.detailDialogTitle = '契約情報詳細画面';
                  tabItem.downloadFileInformation.fileId = response.record.before_signature_file;
                  tabItem.downloadFileInformation.name = response.record.document_name;
                  tabItem.detailItems = this.getHeaderFields(
                    JSON.parse(JSON.stringify(contractInfomationDetailForms))
                  );

                  const contractInfomationDetailData = { 0: '', 1: '', 2: '', 3: '', 4: '', 5: '' };
                  this.getHeaderData(contractInfomationDetailData, tabItem.detailItems);

                  const signingGroupItem = this.signingGroupData.find((item: any) => {
                    if (response.record.signing_group_id === item.value) {
                      return item;
                    }
                  });
                  if (signingGroupItem !== undefined) {
                    const contractTemplateItem = this.contractTemplateSelectData.find((item: any) => {
                      if (signingGroupItem.text === item.text) {
                        return item;
                      }
                    });
                    for (const index in tabItem.detailItems.datas) {
                      if (tabItem.detailItems.datas[index].display_id === 'contractType') {
                        tabItem.detailItems.datas[index].props.selectData.options = this.contractTemplateSelectData;
                        tabItem.detailItems.datas[index].props.value = contractTemplateItem.value;
                      }
                    }
                  }

                  for (const [key, value] of Object.entries(response.record)) {
                    for (const indexB in tabItem.detailItems.datas) {
                      if (key === tabItem.detailItems.datas[indexB].display_id) {
                        if ('long_storage' === tabItem.detailItems.datas[indexB].display_id) {
                          if(value !== "1") {
                            tabItem.detailItems.datas[indexB].props.checkBoxs[0].default = false;
                            tabItem.detailItems.datas[indexB].show = false;
                          } else {
                            tabItem.detailItems.datas[indexB].props.checkBoxs[0].default = true;
                            tabItem.detailItems.datas[indexB].show = true;
                          }
                        } else if ('matter_status_update_flag' === tabItem.detailItems.datas[indexB].display_id) {
                          if(value !== "true") {
                            tabItem.detailItems.datas[indexB].props.checkBoxs[0].default = false;
                            tabItem.detailItems.datas[indexB].show = true;
                          } else {
                            tabItem.detailItems.datas[indexB].props.checkBoxs[0].default = true;
                            tabItem.detailItems.datas[indexB].show = true;
                          }
                        } else {
                          tabItem.detailItems.datas[indexB].props.value = value;
                          // 契約詳細画面の項目に値がない場合は非表示
                          if (
                            tabItem.detailItems.datas[indexB].props.value === null
                            || tabItem.detailItems.datas[indexB].props.value === ''
                          ) {
                            tabItem.detailItems.datas[indexB].show = false;
                          } else {
                            tabItem.detailItems.datas[indexB].show = true;
                          }
                        }
                      }
                    }
                  }
                  tabItem.dialogControl.detailConfirm = true;
                  break;
                }
              }
              break;
            }
            case 'randomNumberInputButton': {
              const tabItem = this.matterTabItems.find((item: any) => {
                if (item.title === '契約') {
                  return item;
                }
              });

              const str = '0123456789';
              let randstr = '';
              const n = 8; // 繰り返し回数
              for (let i = 0; i < n; i++) {
                randstr += str[~~(Math.random() * str.length)];
              }
              if (tabItem !== undefined) {
                tabItem.accessCode.access_code = randstr;
              }
              this.contractSendData['access_code'] = randstr;
              break;
            }
          }
        }
        break;
      }
      default:
        this.inputOperation(response.data, response.index);
        break;
    }
    // switch (response.data.name) {
    //   case 'projectServiceOA.advanceCreditInformation.advance_credit_status':
    //     this.matterInfomationRegisterData.relatedItems.projectServiceOA.estimateInfomation[response.index].advance_credit_status =
    //       response.data.value.value
    //   break;
    //   case 'projectServiceOA.advanceCreditInformation.special_notes':
    //     this.matterInfomationRegisterData.relatedItems.projectServiceOA.estimateInfomation[response.index].special_notes =
    //       response.data.value
    //   break;
    // }
  }

  private async nonContractFileUpload() {
    try {
      this.setLoading(true);
      const results: any = [];
      const addPromises: any = [];
      if (this.contractInfomationItems['field_values'] === undefined) {
        const autoNumber = await this.matter.getAutoNumber(
          this.projectId,
          hexabaseState.datastoreIds['契約情報'],
          'id',
          {}
        );
        const payload: any = {
          'return_item_result': true,
          item: {},
          related_ds_items: {}
        };
        payload.item.system_contract_number = autoNumber.result.value;
        this.basicFieldsData.find((item: any) => {
          if (item.display_id === 'project_id') {
            payload.item.project_id = item.props.value;
          }
        });
        payload['related_ds_items'][this.mainDsId] = [
          {
            'operation': 11,
            'link_to_parent': true,
            'i_id' : this.matterItemId
          }
        ];
        addPromises.push(
          this.matter.registerLinkedItems(
            hexabaseState.applicationId,
            hexabaseState.datastoreIds['契約情報'],
            payload
          )
        );
        addPromises.push(
          this.matter.getFieldsData(
            hexabaseState.applicationId,
            hexabaseState.datastoreIds['文書管理']
          )
        );
      }
      results.push(await Promise.all(addPromises));

      if (this.contractInfomationItemId === '') {
        this.contractInfomationItemId = results[0][0]['item_id'];
        this.nonContractFileRevNo = results[0][0].item.rev_no;
      }

      let upfile = await this.File.uploadFiles(
        this.projectId,
        hexabaseState.datastoreIds['契約情報'],
        this.contractInfomationItemId,
        'non_electronic_contract_file',
        this.nonContractinputFiles
      );

      const current = this.nonContractCurrentFiles.map((file: any) => file.file_id);
      upfile = [...current, ...upfile];
      const updateData: any = {
        item: {} as any,
        'return_item_result': true,
        'rev_no': this.nonContractFileRevNo
      };

      updateData.item['non_electronic_contract_file'] = upfile;
      const changeStatusResult = await this.matter.changeStatus(
        hexabaseState.applicationId,
        hexabaseState.datastoreIds['契約情報'],
        this.contractInfomationItemId,
        'UpdateItem',
        updateData
      );
      const fileList = await this.File.getFileList(
        this.projectId,
        hexabaseState.datastoreIds['契約情報'],
        this.contractInfomationItemId,
        'non_electronic_contract_file'
      );

      this.nonContractCurrentFiles = fileList.files;
      this.nonContractFileRevNo = fileList.rev;
      this.nonContractFileCount = fileList.files.length;
      const tabItem = this.matterTabItems.find((item: any) => {
        if (item.title === '契約') {
          return item;
        }
      });
      if (tabItem !== undefined) {
        tabItem.nonElectronicContractList = this.nonContractCurrentFiles;
        tabItem.nonContractinputFiles = [];
      }
    } finally {
      this.nonContractinputFiles = [];
      this.setLoading(false);
    }
  }

  /**
   * Base64とMIMEコンテンツタイプからBlobオブジェクトを作成する。
   * @param data 文書管理のアイテム
   */
  async contractInDocumentDownload(data: any) {
    try {
      this.$store.commit('hexabase/setIsLoading', true);
      let companyId = '';
      const companyIdItem = this.basicFieldsData.find((item: any) => {
        if (item.display_id === 'company_id') {
          const companyItem = this.masterData.m_company.body.find((recode: any) => {
            if (item.props.value.i_id === recode.i_id) {
              companyId = recode.id;
            }
          });
        }
      });
      const param = {
        application_id: hexabaseState.applicationId,
        company_datastore_id: hexabaseState.datastoreIds['企業マスタ'],
        company_id: companyId,
        xid: data.record.xid
      };

      const apiResult:any = await this.simwork.triggerGetDoc(param);
      if (apiResult.error === true) {
        this.openGeneralDialog('文書ダウンロードエラー', '文書をダウンロードできませんでした。', false);
      } else {
        const url = window.URL.createObjectURL(
          this.toBlob(apiResult.data.pdf_data, 'application/pdf')
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', data.record.document_name);
        document.body.appendChild(link);
        link.click();
      }
    } catch (errorMessage) {
      if (errorMessage.message !== '') {
        this.setError(errorMessage.message);
      } else {
        this.setError(errorMessage);
      }
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * Base64とMIMEコンテンツタイプからBlobオブジェクトを作成する。
   * 日本語対応。
   * @param base64
   * @param mime_ctype MIMEコンテンツタイプ
   * @returns Blob
   */
  toBlob(base64: any, mime_ctype: any) {
    // 日本語の文字化けに対処するためBOMを作成する。
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);

    const bin = atob(base64.replace(/^.*,/, ''));
    const buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    // Blobを作成
    let blob = new Blob();
    try {
      blob = new Blob([bom, buffer.buffer], { type: mime_ctype });
    } catch (e) {
      return false;
    }
    return blob;
  }

  async getSignatureRequest() {
    const tabItem = this.matterTabItems.find((item: any) => {
      if (item.title === '契約') {
        return item;
      }
    });

    const reportPayload: any = {
      conditions: [
        { "id":"project_id",  "search_value":[this.contractSendData['project_id']] }
      ],
      per_page: 0,
      page: 1
//      include_lookups: true
    };
    let dataReportResult: any = {}
    try {
      tabItem!.isLoading = true;
      const results: any = [];
      const addPromises: any = [];
      dataReportResult = await this.matter.getReports(this.projectId, this.contractDocumentData.dataReportId, reportPayload);

      if (dataReportResult.report_results.length === 0) {
        throw new Error('契約書情報がありません。');
      } else {
        if (this.contractInfomationItems['field_values'] === undefined) {
          const autoNumber = await this.matter.getAutoNumber(
            this.projectId,
            hexabaseState.datastoreIds['契約情報'],
            'id',
            {}
          );
          const payload: any = {
            'return_item_result': true,
            item: {},
            related_ds_items: {}
          };
          payload.item.system_contract_number = autoNumber.result.value;
          this.contractSendData['system_contract_number'] = payload.item.system_contract_number;
          payload.item.project_id = this.contractSendData['project_id'];
          payload['related_ds_items'][this.mainDsId] = [
            {
              'operation': 11,
              'link_to_parent': true,
              'i_id' : this.matterItemId
            }
          ];
          addPromises.push(
            this.matter.registerLinkedItems(
              hexabaseState.applicationId,
              hexabaseState.datastoreIds['契約情報'],
              payload
            )
          );
          addPromises.push(
            this.matter.getFieldsData(
              hexabaseState.applicationId,
              hexabaseState.datastoreIds['文書管理']
            )
          );
        } else {
          this.contractSendData['system_contract_number'] = this.contractInfomationItems[
            'field_values'
          ].system_contract_number.value;
        }

        results.push(await Promise.all(addPromises));

        if (this.contractInfomationItemId === '') {
          this.contractInfomationItemId = results[0][0]['item_id'];
        }

        const payload = {
          root_list: [
            {
              keiyakusho: JSON.parse(JSON.stringify(dataReportResult.report_results[0] !== undefined ? dataReportResult.report_results[0] : {}))
            }
          ]
        }

        const fileName = this.contractSendData['document_name'];
        const actionResponse = await this.matter.changeStatus(
          this.projectId,
          hexabaseState.datastoreIds['契約情報'],
          this.contractInfomationItemId,
          'output',
          {
            is_force_update: true,
            as_params: {
              templates: {
                type: 'pdf',
                fileId: this.contractDocumentData.docurainTemplateFile
              },
              filename: fileName,
              data: payload
            }
          }
        );

        if(actionResponse !== undefined) {
          const response = actionResponse.details.result;
          if (response.status == 200) {
            const uploadFileId = response.file_id;
            const getfile = await this.matter.getFile(response.file_id);
            const blob = getfile;
            const type = 'application/pdf';
            const contents = new Blob([blob], { type: type });
            const base = await this.getBase64(contents)
              .then((data: any) => {
                //data:application/pdf;base64,を削除する
                const byteString = data.split(',')[1];
                return byteString;
              })
              .catch(error => this.setError(error));
            this.contractSendData.document = base;
            const res: any = await this.simwork.triggerRegisterDocumentSign(this.contractSendData);
            if (res.error === true) {
              throw new Error('エラーが発生し、署名依頼を行えませんでした。');
            } else {
              const formData = new FormData();
              // 文書管理トランのrev_noを取得するため、署名依頼の後に行う
              const itemListResult: any = await this.matter.getItemList(
                hexabaseState.applicationId,
                hexabaseState.datastoreIds['文書管理'],
                {
                  'conditions': [{ 'id': 'i_id', 'search_value': [res.data.item_id] } ],
                  'page': 1,
                  'per_page': 0
                }
              );

              //文書管理トラン 選択肢項目(matter_status_update_flag)の選択肢のdisplay_idを取得
              const matterItemDetails = await this.matter.getItemDetails(hexabaseState.applicationId, hexabaseState.datastoreIds['文書管理'], res.data.item_id)
              const field: any = Object.values(matterItemDetails.fields).find(
                (field: any) => field.display_id === 'matter_status_update_flag'
              );
              if (this.contractSendData.matter_status_update_flag === true) {
                const flag = field.options.find((option: any) => option.value === 'true');
                this.matterStatusUpdateFlag = flag.display_id;
              } else {
                const flag = field.options.find((option: any) => option.value === 'false');
                this.matterStatusUpdateFlag = flag.display_id;
              }

              //シムワーク側で文書管理トランへのアイテム登録を行っているため、項目によっては別途updateによるデータ登録が必要
              const updateData: any = {
                item: {} as any,
                'related_ds_items': {},
                'rev_no': Number(itemListResult[0].rev_no)
              };
              updateData.item['before_signature_file'] = [uploadFileId];
              const date = DateTime.local();
              updateData['item']['signature_request_date'] = date.toFormat('yyyy-MM-dd').toString();
              updateData['item']['matter_status_update_flag'] = this.matterStatusUpdateFlag;
              updateData['related_ds_items'][hexabaseState.datastoreIds['契約情報']] = [
                {
                  "operation" : 11,
                  "link_to_parent": true,
                  "i_id" : this.contractInfomationItemId
                }
              ];

              const changeStatusResult = await this.matter.changeStatus(
                hexabaseState.applicationId,
                hexabaseState.datastoreIds['文書管理'],
                res.data.item_id,
                'UpdateItem',
                updateData
              );
            }
          }
        }
      }
    } catch (errorMessage) {
      if (errorMessage.message) {
        this.setError(errorMessage.message);
      } else {
        this.setError(errorMessage);
      }
    } finally {
      this.signatureDialogDataInitialization(tabItem);
      tabItem!.dialogControl.register = false;
      tabItem!.dialogControl.detailConfirm = false;
      const data = await this.matter.getLinkedItems(
        this.projectId,
        hexabaseState.datastoreIds['契約情報'],
        this.contractInfomationItemId,
        '&use_display_id=true'
      );
      if (data !== undefined) {
        this.contractInfomationItems = data;
      }
      tabItem!.isLoading = false;
      this.getContractDataFlag = false;
      this.getContractTabItemListUpdate();
    }
  }

  // 署名依頼ダイアログを閉じた際に各項目の値を初期化
  private signatureDialogDataInitialization(tabItem: any) {
    tabItem.selectContractTypeItems = {
      value: '0', // 署名依頼ダイアログの再表示に再描画させるための仮値
      selectData: []
    },
    tabItem.fileUploadItems = {};
    tabItem.partnerSignaturePositionItems = {};
    tabItem.ourSignaturePositionItems = {};
    tabItem.dialogButtonType = true;
    tabItem.detailItems = {};
    tabItem.accessCode.access_code = '';
    tabItem.accessCode.isShowAccessCode = false;
  }

  private getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  private changeSelect(data: any) {
    switch (data.name) {
      case 'billing_payment_information':
        // 請求先支払情報
        this.customerDepartmentPaymentInfomationItem.selected = data.value.value;
        // 登録情報にも反映
        this.matterInfomationRegisterData[
          'billing_payment_information'
        ] = this.customerDepartmentPaymentInfomationItem.selected;
        break;
      case 'payment_information':
        // 支払情報
        this.paymentInfomationItem.selected = data.value.value;
        // 登録情報にも反映
        this.matterInfomationRegisterData[
          'payment_information'
        ] = this.paymentInfomationItem.selected;
        break;
      default:

        break;
    }
  }

  private clearExecDialog(response: any) {
    this.isExecDialog = false;
    if (response !== undefined && response.isAgree) {
      this.redirectTo(this.redirectTargetParam);
    }
  }

  /**
   * 戻る処理
   */
  private backPreviousPage() {
    const beforeRoute = { name: this.prevRoute.name, params: this.prevRoute.params, query: {} };

    if (this.prevRoute) {
      const paths = this.prevRoute.fullPath.split('/');
      if (['list', 'searchlist'].includes(paths[paths.length - 1].toLowerCase())) {
        beforeRoute.query = { searchConditions: 'true' };
      }
    }

    this.$router.push(beforeRoute);
  }

  private redirectTo(request: any) {
    this.$router.push(request);
  }

  /**
   * ヘッダー取得
   */
  private getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.estimate.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      if (typeof errorMessage === 'string') {
        this.setError(errorMessage);
      }
    }
    return baseData;
  }

  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      if (typeof errorMessage === 'string') {
        this.setError(errorMessage);
      }
    }
  }

  /**
   * マスタデータ取得
   */
  private async getMasterData() {
    // マスターデータを取得しグローバル変数に格納
    await this.matter.getEditMasterData();
    this.masterData = this.matter.getMaster();

    // 顧客
    for (const key in this.masterData['m_customer'].body) {
      this.masterSelectCustomerData.push(this.masterData['m_customer'].body[key]);
    }
    // 顧客部署
    // for (const key in this.masterData['m_customer_department'].body) {
    //   // this.masterSelectCustomerDepartmentData.push(this.masterData['m_customer_department'].body[key]);
    // }
    // サービス種別
    for (const key in this.masterData.m_service_type.body) {
      this.masterSelectServiceTypeData.push(this.masterData.m_service_type.body[key]);
    }
    // リース会社
    this.leasingCompanyColumns = this.masterData['m_leasing_company'].columns;
    for (const key in this.masterData['m_leasing_company'].body) {
      this.leasingCompanyDatas.push(this.masterData['m_leasing_company'].body[key]);
    }
    // 支払情報
    for (const key in this.masterData.m_payment_information.body) {
      const type = this.masterData.m_payment_information.body[key].service_type_id;
      if (this.paymentInformationLists[type] === undefined) {
        this.paymentInformationLists[type] = [];
      }
      this.paymentInformationLists[type].push({
        value: this.masterData.m_payment_information.body[key].i_id,
        text: this.masterData.m_payment_information.body[key].payment_information
      });
    }
    // 与信商品
    for (const key in this.masterData.m_credit_product.body) {
      this.masterCreditProductData.push(this.masterData.m_credit_product.body[key]);
    }
  }

  /**
   * アプリケーション関連データ取得
   */
  private async getApplicationData(matterDatas: any) {
    const matterValues = matterDatas.field_values;
    Object.values(matterValues).forEach((fieldValue: any) => {
      const fieldId = fieldValue.field_id;
      if (fieldId in this.matterInfomationRegisterData) {
        const fieldValue: any = Object.values(matterValues).find(
          (matterValue: any) => matterValue.field_id === fieldId
        );
        if (fieldValue && fieldValue.value) {
          if (fieldValue.dataType === 'dslookup') {
            const serviceType = this.masterData.m_service_type.body.find(
              (serviceType: any) => serviceType.i_id === fieldValue.value.item_id
            );
            if (serviceType) {
              this.screenStructureType = serviceType.screen_structure_type;
            }
          }
        }
      }
    });

    const initialAction = this.matter.getFormDisplayAction(this.itemActions, 'update');

    // 顧客連絡先
    const matterCustomer: any = Object.values(matterValues).find((matterValue: any) => {
      return matterValue.field_id === 'customer_id';
    });
    const customerItemId = matterCustomer.value.item_id;
    this.customerItemId = customerItemId;

    // 関連データ
    const matterLinkedItems = matterDatas.linked_items;
    if (this.screenStructureType === '1') {
      this.matterLinkedItem = Object.values(matterLinkedItems).find(
        (matterLinkedItem: any) => matterLinkedItem.display_id === 't_project_service_OA'
      );
      // 案件サービス別OAのitemID退避
      this.projectServiceOAItemId = this.matterLinkedItem.items[0].i_id;
    }
    if (this.screenStructureType === '2') {
      this.matterLinkedItem = Object.values(matterLinkedItems).find(
        (matterLinkedItem: any) => matterLinkedItem.display_id === 't_project_service_fjapan'
      );
    }
    if (this.screenStructureType === '99') {
      this.matterLinkedItem = Object.values(matterLinkedItems).find(
        (matterLinkedItem: any) => matterLinkedItem.display_id === 't_project_service_general'
      );
    }
    // 子テーブル
    this.projectServiceDsId = this.matterLinkedItem.d_id;
    const item = this.matterLinkedItem.items[0];

    // 添付ファイル
    this.fileUploadTarget.datastoreId = this.projectServiceDsId;
    this.fileUploadTarget.itemId = item.i_id;

    // 契約情報の確認
    if (
      matterDatas.linked_items[hexabaseState.datastoreIds['契約情報']].items.length !== 0 ||
      this.contractInfomationItems['field_values'] !== undefined
    ) {
      if (this.contractInfomationItemId === '') {
        this.contractInfomationItemId = matterDatas.linked_items[
          hexabaseState.datastoreIds['契約情報']
        ].items[0].i_id;
      }
    }

    const addPromises: any = [];
    const actionListRelatedDs:any = {};
    // 各サービス種別共通のAPI設定
    // 顧客マスタのアイテム取得
    addPromises.push(this.customer.getItemDetails(this.projectId, this.customerDsId, customerItemId));
    addPromises.push(this.matter.getLinkedItems(this.projectId, this.projectServiceDsId, item.i_id));
    addPromises.push(this.getFiles());
    // フィールド情報
    addPromises.push(this.matter.getFieldsByActionId(this.mainDsId, initialAction!.action_id));
    addPromises.push(this.matter.makeFieldsList(this.projectId, this.mainDsId, this.currentData));

    // 各サービス種別でのAPI設定
    switch (this.screenStructureType) {
      case '1': {
        // サービス種別：OAリース
        // OAリースでAPIに必要なパラメータ
        // XXX取得
        addPromises.push(
          // Get new action-list(copy-related-ds)
          Object.entries(CopyDSNamesOA).map(async CopyDSNamesOA => {
            const storeName = CopyDSNamesOA[1];
            const dsId = hexabaseState.datastoreIds[storeName];
            this.matter.getNewActionList(dsId).then(response => {
              let action: actionList | undefined;
              switch (CopyDSNamesOA[0]) {
                case 'estimateBasicInfomationOA':{
                  action = response.actions.find(action => action.display_id === 'temporarily_save');
                  break;
                }
                default: {
                  action = response.actions.shift();
                  break;
                }
              }
              if (action !== undefined) {
                this.matter
                  .getFieldsByActionId(dsId, action.action_id)
                  .then(fields => (this.copyRelatedFields[CopyDSNamesOA[0]] = fields));
              }
            });
          })
        );
        addPromises.push(
          // Get new action-list(related-ds)
          Object.entries(RelatedDatastoreNamesOA).map(async (RelatedDatastoreNamesOA) => {
            const storeName = RelatedDatastoreNamesOA[1];
            const dsId = hexabaseState.datastoreIds[storeName];

            actionListRelatedDs[storeName] = await this.matter.getNewActionList(dsId);
          })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds['案件サービス別OA'])
            .then(response => {
              // 本信ステータス
              const trueStatusField = Object.values(response.fields).find(
                (field: any) => field.display_id === 'true_status'
              );
              if (trueStatusField && trueStatusField.options) {
                this.selectCreditStatusItem = trueStatusField.options.map((option: any) => {
                  return { text: option.value, value: option.option_id };
                });
              }
              // Get field info
              this.projectServiceFields['1'] = response;
            })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds['見積基本情報OA'])
            .then(response => {
              this.estimateBasicInfoOaFields = response;
            })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds['リース会社マスタ'])
            .then(response => {
              this.leasingCompanyFields = response;
            })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds['案件与信OA'])
            .then(response => {
              this.projectCreditFields = response;
            })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds['与信商品マスタ'])
            .then(response => {
              this.creditProductFields = response;
            })
        );
        break;
      }
      case '2': {
        // サービス種別：F-Japan
        // 汎用でAPIに必要なパラメータ
        // YYY取得
        addPromises.push(
          Object.entries(CopyDSNamesFJapan).map(async CopyDSNamesFJapan => {
            const storeName = CopyDSNamesFJapan[1];
            const dsId = hexabaseState.datastoreIds[storeName];
            this.matter.getNewActionList(dsId).then(response => {
              let action: actionList | undefined;
              switch (CopyDSNamesFJapan[0]) {
                case 'estimateBasicInfomationFJapan': {
                  action = response.actions.find(action => action.display_id === 'temporarily_save');
                  break;
                }
                default: {
                  action = response.actions.shift();
                  break;
                }
              }
              if (action !== undefined) {
                this.matter
                  .getFieldsByActionId(dsId, action.action_id)
                  .then(fields => (this.copyRelatedFields[CopyDSNamesFJapan[0]] = fields));
              }
            });
          })
        );
        addPromises.push(
          // Get new action-list(related-ds)
          Object.entries(RelatedDatastoreNamesFJapan).map(async (RelatedDatastoreNamesFJapan) => {
            const storeName = RelatedDatastoreNamesFJapan[1];
            const dsId = hexabaseState.datastoreIds[storeName];

            this.matter.getNewActionList(dsId).then(response => {
              const action = response.actions.shift();
              if (action !== undefined) {
                this.matter
                .getFieldsByActionId(dsId, action.action_id)
                .then(fields => {
                  this.relatedFields[RelatedDatastoreNamesFJapan[0]] = fields;
                  },
                );
              }
            });
          })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds[DSNames[this.screenStructureType].PROJECT_SERVICE])
            .then(response => {
              // Get field info
              this.projectServiceFields['2'] = response;
            })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds[DSNames[this.screenStructureType].ESTIMATE_BASIC_INFOMATION])
            .then(response => {
              this.estimateBasicInfoFJapanFields = response;
            })
        );
        break;
      }
      case '99': {
        // サービス種別：汎用
        // 汎用でAPIに必要なパラメータ
        // YYY取得
        addPromises.push(
          Object.entries(CopyDSNamesGeneral).map(async CopyDSNamesGeneral => {
            const storeName = CopyDSNamesGeneral[1];
            const dsId = hexabaseState.datastoreIds[storeName];
            this.matter.getNewActionList(dsId).then(response => {
              let action: actionList | undefined;
              switch (CopyDSNamesGeneral[0]) {
                case 'estimateBasicInfomationGeneral': {
                  action = response.actions.find(action => action.display_id === 'temporarily_save');
                  break;
                }
                default: {
                  action = response.actions.shift();
                  break;
                }
              }
              if (action !== undefined) {
                this.matter
                  .getFieldsByActionId(dsId, action.action_id)
                  .then(fields => (this.copyRelatedFields[CopyDSNamesGeneral[0]] = fields));
              }
            });
          })
        );
        addPromises.push(
          // Get new action-list(related-ds)
          Object.entries(RelatedDatastoreNamesGeneral).map(async (RelatedDatastoreNamesGeneral) => {
            const storeName = RelatedDatastoreNamesGeneral[1];
            const dsId = hexabaseState.datastoreIds[storeName];

            this.matter.getNewActionList(dsId).then(response => {
              const action = response.actions.shift();
              if (action !== undefined) {
                this.matter
                .getFieldsByActionId(dsId, action.action_id)
                .then(fields => {
                  this.relatedFields[RelatedDatastoreNamesGeneral[0]] = fields;
                  },
                );
              }
            });
          })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds['案件サービス別汎用'])
            .then(response => {
              // Get field info
              this.projectServiceFields['99'] = response;
            })
        );
        addPromises.push(
          this.matter
            .getField(this.projectId, hexabaseState.datastoreIds['見積基本情報汎用'])
            .then(response => {
              this.estimateBasicInfoGeneralFields = response;
            })
        );
        break;
      }
      default: {
        break;
      }
    }
    // 契約情報
    if (
      matterDatas.linked_items[hexabaseState.datastoreIds['契約情報']].items.length !== 0 ||
      this.contractInfomationItems['field_values'] !== undefined
    ) {
      addPromises.push(this.matter.getLinkedItems(
        hexabaseState.applicationId,
        hexabaseState.datastoreIds['契約情報'],
        this.contractInfomationItemId,
        '&use_display_id=true'
      ))
    }

    // パラレル化したAPI実行
    const results:any = await Promise.all(addPromises);
    // APIレスポンス設定
    this.customerItemDetail = results[0];
    this.inputFields = results[3];
    this.fieldsData = results[4];
    // 各サービス種別でのAPIレスポンス設定
    switch (this.screenStructureType) {
      case '1': {
        // サービス種別：OAリース
        //API実行
        const addPromise: any = [];
        // Get new action-list(related-ds)のAPI実行後に実行が必要な処理（上記のPromise.allでのパラレル化は不可）
        // actionlistを元にフィールド情報（案件サービス別OA、与信）を取得
        Object.entries(actionListRelatedDs).map(async (RelatedDatastoreNamesOA) => {
          const storeName:any = RelatedDatastoreNamesOA[0];
          const dsId = hexabaseState.datastoreIds[storeName];
          const data:any = RelatedDatastoreNamesOA[1];
          const action:any = data.actions.shift();
          addPromise.push(this.matter.getFieldsByActionId(dsId, action.action_id));
        });
        const result:any = await Promise.all(addPromise);

        // フィールド情報を元に事前与信ステータス、事前与信状況関連の値を取得
        for (let i = 0; i < result.length; i++) {
          const displayIdCredit:any = Object.values(result[i].action_fields).find(
            (field: any) => field.display_id === 'credit_status'
          );
          // 案件与信OAの審査結果
          const displayIdCheck:any = Object.values(result[i].action_fields).find(
            (field: any) => field.display_id === 'check_status'
          );
          if (displayIdCredit) {
            this.relatedFields['projectServiceOA'] = result[i];
            const creditStatus:any = Object.values(result[i].action_fields).find(
              (field: any) => field.display_id === 'credit_status'
            );
          }
          if (displayIdCheck) {
            this.relatedFields['projectCreditOA'] = result[i];
            const checkStatus:any = Object.values(result[i].action_fields).find(
              (field: any) => field.display_id === 'check_status'
            );
            // 案件与信OAの審査結果用の値を取得
            this.checkStatusItem = checkStatus.options
              .sort((a: any, b: any) => {
                return (a.sort_id < b.sort_id) ? -1 : 1;
              })
              .map((option: any) => {
                return { value: option.option_id, text: option.value };
              });
          }
        }

        this.projectServiceOa = results[1];
        if (results.length > 12) {
          this.contractInfomationItems = results[12];
        }
        break;
      }
      case '2': {
        // サービス種別：F-Japan
        this.projectServiceFJapan = results[1];
        if (results.length > 9) {
          this.contractInfomationItems = results[9];
        }
        break;
      }
      case '99': {
        // サービス種別：汎用
        this.projectServiceGeneral = results[1];
        if (results.length > 9) {
          this.contractInfomationItems = results[9];
        }
        break;
      }
      default: {
        break;
      }
    };
  }

  /**
   * 初期値設定
   */
  private async getInitialValues(matterDatas: any) {
    if (matterDatas) {
      await this.getApplicationData(matterDatas);
      await this.setMatterData(matterDatas);
      await this.createBasicData(this.inputFields, this.fieldsData);
      this.materialListTabItems.splice(0);
      const materialListTabItems = JSON.parse(JSON.stringify(MaterialListTabItems.Update[this.screenStructureType]));
      for (const [index, tabItem] of materialListTabItems.entries()) {
        this.$set(this.materialListTabItems, index, tabItem);
      }
      this.matterTabItems.splice(0);
      for (const [index, tabItem] of MatterTabItems.Update[this.screenStructureType].entries()) {
        this.$set(this.matterTabItems, index, JSON.parse(JSON.stringify(tabItem)));
      }
      this.setTabItems();
    }
  }

  private async createBasicData(inputFields:any, fieldsData:any) {
    this.matterFields = inputFields;
    const data = this.matter
      .addOptionalFormField(
        fieldsData.filter((v:any) => v.dataType !== 'status'),
        // サービス種別によって、項目名が変わるのでconcatで結合
        this.matter.deepCopy(matterEditOptionalForm.concat(matterOptionalChangeForm[this.screenStructureType])),
        true
      )
      .map((field) => this.matter.inputRestriction(field, inputFields))
      .map((field) => this.matter.addOptionalMasterData(field, this.masterData))
      .map((field) => {
        if (field.dataType === 'dslookup') {
          field.props!.isBtnVisible = false;
        }
        field.props!.isReadonly = true;
        field.props!.isDisabled = true;
        return field;
      })
      .map((field) => {
        if (field.dataType === 'dslookup' && field.component === 'SelectArea') {
          field.props!.value = field.props!.value.item_id;
        }
        return field;
      });
    // フォーカス調整のため要素を並べ替え
    const sortwk1 = data.sort(function(a, b) {
      return (a.col || 0) - (b.col || 0);
    });
    const sortwk2 = sortwk1.sort(function(a, b) {
      return (a.row || 0) - (b.row || 0);
    });
    this.basicFieldCols = this.customer.getGridStatus(sortwk2);
    this.basicFieldsData = sortwk2;
    this.basicFieldsData.push(({
      display_id: 'status',
      component: 'StatusBox',
      props: {
        labelName: '案件ステータス',
        displayStatus: this.displayStatus
      },
      row: 1,
      col: 8,
      sizeX: 1,
      sizeY: 1,
      show: true,
      show_list: true
    } as unknown) as FieldChildrenProp);
    this.basicFieldsData.find(v => v.display_id === 'department_billing_address_id')![
      'props'
    ]!.body = this.masterSelectCustomerDepartmentData;
    this.basicFieldsData.find(v => v.display_id === 'department_delivery_destination_id')![
      'props'
    ]!.body = this.masterSelectCustomerDepartmentData;
    this.basicFieldsData.find(v => v.display_id === 'payment_information')![
      'props'
    ]!.selectData = this.paymentInfomationItem;
    // 請求先支払情報
    const billingPaymentInformation = Object.values(this.matterFields.action_fields).find((value) => {
      return value.display_id === 'billing_payment_information';
    });
    const billingPaymentInformations = billingPaymentInformation.options
      .sort((a: any, b: any) => {
        return a.sort_id < b.sort_id ? -1 : 1;
      })
      .map((option: any) => {
        return { value: option.option_id, text: option.value };
      });
    this.$set(this.customerDepartmentPaymentInfomationItem, 'options', billingPaymentInformations);
  }

  private async setMatterData(matterDatas: any) {
    try {
      const matterData = matterDatas;

      if (matterData) {
        this.matterData = matterData;
        // Get Header
        this.matterHeaderData = this.getHeaderFields(
          JSON.parse(JSON.stringify(MatterHeaderColumns))
        );

        // Header
        this.getHeaderData(
          {
            0: this.matterData.created_by,
            1: this.matter.editDatetype(this.matterData.created_at, 'Asia/Tokyo', 'yyyy/MM/dd')
          },
          this.matterHeaderData
        );

        if (this.statusAction) {
          this.execAllowActions = this.statusAction.filter(
            v => !v.display_id!.indexOf('project_basic_info')
          ) as Array<ActionButtons>;
          this.statusButton = this.matter.statusButtonList(this.execAllowActions, this.matterData);
        }
        // Status
        const statusValue = matterData.field_values.find(
          (v: { dataType: string }) => v.dataType === 'status'
        )!.value;
        const currentStatus = this.statusList.find(v => v.status_id === statusValue);
        this.displayStatus = currentStatus!.status_name;

        const matterValues = matterData.field_values;
        Object.values(matterValues).forEach((fieldValue: any) => {
          const fieldId = fieldValue.field_id;
          if (fieldId in this.matterInfomationRegisterData) {
            const fieldValue: any = Object.values(matterValues).find(
              (matterValue: any) => matterValue.field_id === fieldId
            );
            if (fieldValue && fieldValue.value) {
              let value: any = '';
              if (fieldValue.dataType === 'dslookup') {
                switch (fieldValue.field_id) {
                  case 'service_type_id': {
                    const serviceType = this.masterData.m_service_type.body.find(
                      (serviceType: any) => serviceType.i_id === fieldValue.value.item_id
                    );
                    if (serviceType) {
                      this.serviceType = serviceType.service_type;
                      this.screenStructureType = serviceType.screen_structure_type;
                      this.masterSelectServiceTypeSelected = {
                        i_id: fieldValue.value.item_id
                      };
                    }
                    break;
                  }
                  case 'customer_id':
                    this.masterSelectCustomerSelected = {
                      i_id: fieldValue.value.item_id
                    };
                    break;
                  case 'department_billing_address_id':
                    this.masterSelectCustomerDepartmentFromSelected = {
                      i_id: fieldValue.value.item_id
                    };
                    break;
                  case 'department_delivery_destination_id':
                    this.masterSelectCustomerDepartmentToSelected = {
                      i_id: fieldValue.value.item_id
                    };
                    break;
                  default:
                    break;
                }
                value = fieldValue.value.item_id;
              } else {
                value = fieldValue.value;
              }
              this.$set(this.matterInfomationRegisterData, fieldId, value);
            }
          }
        });
        const telephoneNumber = this.customerItemDetail.field_values.find(
          (field: any) => field.field_id === 'telephone_number'
        );
        this.$set(this.matterInfomationRegisterData, 'telephone_number', telephoneNumber.value);
        
        // 関連データ
        const matterLinkedItems = matterDatas.linked_items;
        if (matterLinkedItems) {
          const serviceTypeList = Object.fromEntries(
            Object.values(this.masterData.m_service_type.body).map((value) => [
              value.service_type,
              value.screen_structure_type
            ])
          );
          switch (serviceTypeList[this.serviceType]) {
            case '1': {
              const matterLinkedItem: any = Object.values(matterLinkedItems).find(
                (matterLinkedItem: any) => matterLinkedItem.display_id === 't_project_service_OA'
              );
              if (matterLinkedItem) {
                // 子テーブル
                this.projectServiceDsId = matterLinkedItem.d_id;
                const item = matterLinkedItem.items[0];
                const projectServiceOa = this.projectServiceOa;
                if (projectServiceOa !== undefined) {
                  const projectService = this.matterInfomationRegisterData.relatedItems
                    .projectServiceOA;
                  this.$set(projectService, 'i_id', item.i_id);
                  this.$set(projectService, 'rev_no', item.rev_no);
                  const fieldValues = projectServiceOa.field_values;
                  fieldValues.forEach((fieldValue: any) => {
                    if (fieldValue.value) {
                      // 与信＋本信
                      if (fieldValue.dataType === 'dslookup') {
                        if (fieldValue.field_id === 'final_estimate_id') {
                          const estimateItem = fieldValue.value.lookup_item;
                          // リース会社
                          const leasingCompanyField: any = Object.values(
                            this.estimateBasicInfoOaFields.fields
                          ).find((field: any) => field.display_id === 'leasing_company_id');
                          const leasingCompanyItem =
                            estimateItem.lookup_items[leasingCompanyField.field_id];
                          if (leasingCompanyItem) {
                            const leasingCompanyIdField: any = Object.values(
                              this.leasingCompanyFields.fields
                            ).find((field: any) => field.display_id === 'id');
                            this.$set(
                              projectService,
                              'leasingCompanyId',
                              leasingCompanyItem[leasingCompanyIdField.field_id]
                            );
                            const leasingCompanyNameField: any = Object.values(
                              this.leasingCompanyFields.fields
                            ).find((field: any) => field.display_id === 'leasing_company');
                            this.$set(
                              projectService,
                              'leasingCompanyName',
                              leasingCompanyItem[leasingCompanyNameField.field_id]
                            );
                            const telephoneNumberField: any = Object.values(
                              this.leasingCompanyFields.fields
                            ).find((field: any) => field.display_id === 'telephone_number');
                            this.$set(
                              projectService,
                              'leasingCompanyPhoneNumber',
                              leasingCompanyItem[telephoneNumberField.field_id]
                            );
                          }
                          // 最終見積版名
                          const estimateSubjectField: any = Object.values(
                            this.estimateBasicInfoOaFields.fields
                          ).find((field: any) => field.display_id === 'estimate_subject');
                          this.$set(
                            projectService,
                            'estimate_subject',
                            estimateItem[estimateSubjectField.field_id]
                          );
                          const estimateVerisonNameField: any = Object.values(
                            this.estimateBasicInfoOaFields.fields
                          ).find((field: any) => field.display_id === 'estimate_version_name');
                          this.$set(
                            projectService,
                            'estimate_version_name',
                            estimateItem[estimateVerisonNameField.field_id]
                          );
                          // 料率、契約年数
                          // Fix: 初期表示時はテーブルに登録されている値を優先する
                          // const rateIdField: any = Object.values(this.estimateBasicInfoOaFields.fields)
                          //   .find((field: any) => field.display_id === 'rate_id');
                          // const rateItem = estimateItem.lookup_items[rateIdField.field_id];
                          // if (rateItem) {
                          //   const rateField: any = Object.values(this.rateFields.fields).find((field: any) => field.display_id === 'rate');
                          //   this.$set(projectService, 'final_rate', rateItem[rateField.field_id]);
                          //   const contractMonthsCalculationField: any = Object.values(this.rateFields.fields).find((field: any) => field.display_id === 'contract_months_calculation');
                          //   this.$set(projectService, 'contract_month', rateItem[contractMonthsCalculationField.field_id]);
                          // }
                        }
                        this.$set(projectService, fieldValue.field_id, {
                          i_id: fieldValue.value.item_id
                        });
                      } else {
                        this.$set(projectService, fieldValue.field_id, fieldValue.value);
                      }
                    }
                  });

                  const linkedItems: any = Object.values(projectServiceOa.linked_items);
                  await Promise.all(
                    linkedItems.map(
                      async (linkedItem: {
                        display_id: string;
                        d_id: string;
                        fields: any;
                        items: any[];
                      }) => {
                        switch (linkedItem.display_id) {
                          case 't_estimate_basic_infomation_OA': {
                            // 見積
                            this.estimateDsId = linkedItem.d_id;
                            const estimateFields = linkedItem.fields;

                            this.estimateItems.splice(0);
                            const iIds = linkedItem.items.map((item: any) => item.i_id as string);
                            const linkedItemResult: { [k: string]: any }[] = await Promise.all(
                              iIds.map(async (id: string) => {
                                const linkedResponse = await Promise.all([
                                  this.matter.getLinked(
                                    this.projectId,
                                    't_estimate_basic_infomation_OA',
                                    id,
                                    hexabaseState.datastoreIds['見積書発行履歴'],
                                    true
                                  ),
                                  this.matter.getLinked(
                                    this.projectId,
                                    't_estimate_basic_infomation_OA',
                                    id,
                                    hexabaseState.datastoreIds['案件サービス別OA'],
                                    true
                                  )
                                ]);
                                const response = { has_error: false, result: {} as any };
                                linkedResponse.forEach(link => {
                                  if (link.result) {
                                    response.has_error = link.has_error;
                                    for (const [dbDisplayId, info] of Object.entries(link.result)) {
                                      response.result[dbDisplayId] = info;
                                    }
                                  }
                                });
                                return { ...response, ...{ i_id: id } };
                              })
                            );
                            linkedItem.items.forEach((item: any, index: number) => {
                              const estimateItemId = item.i_id;
                              const estimateItem: any = {};
                              const finalEstimateIdField: any = Object.values(
                                this.projectServiceFields[1].fields
                              ).find((field: any) => field.display_id === 'final_estimate_id');
                              // 案件情報が持つ最終見積IDと一覧の見積IDが等しければ
                              if (
                                matterLinkedItem.items[0].lookup_items !== undefined &&
                                matterLinkedItem.items[0].lookup_items[
                                  finalEstimateIdField.field_id
                                ] !== undefined &&
                                estimateItemId ===
                                  matterLinkedItem.items[0].lookup_items[
                                    finalEstimateIdField.field_id
                                  ].i_id
                              ) {
                                estimateItem['final_quote'] = '●';
                                this.finalQuoteItems.push(item);
                              }
                              Object.keys(item).map((key: string) => {
                                const field: any = Object.values(estimateFields).find(
                                  (field: any) => field.f_id === key
                                );
                                if (field !== undefined) {
                                  if (field.dataType === 'dslookup') {
                                    if (field.display_id === 'commodity_id') {
                                      if (item.lookup_items && item.lookup_items[key]) {
                                        const commodityField = Object.values(
                                          this.commodityFields.fields
                                        ).find((field: any) => field.display_id === 'commodity');
                                        estimateItem['commodity_name'] =
                                          commodityField !== undefined
                                            ? item.lookup_items[key][
                                                (commodityField as { [k: string]: string }).field_id
                                              ]
                                            : '';
                                        estimateItem['commodity_id'] = item.lookup_items[key].i_id;
                                      }
                                    } else if (field.display_id === 'leasing_company_id') {
                                      if (item.lookup_items && item.lookup_items[key]) {
                                        const leasingField = Object.values(
                                          this.leasingCompanyFields.fields
                                        ).find(
                                          (field: any) => field.display_id === 'leasing_company'
                                        );
                                        estimateItem['leasing_name'] =
                                          leasingField !== undefined
                                            ? item.lookup_items[key][
                                                (leasingField as { [k: string]: string }).field_id
                                              ]
                                            : '';
                                        estimateItem['leasing_company_id'] =
                                          item.lookup_items[key].i_id;
                                      }
                                    } else {
                                      item[key] =
                                        item.lookup_items && item.lookup_items[key]
                                          ? item.lookup_items[key].i_id
                                          : item[key];
                                      estimateItem[field.display_id] = item[key];
                                    }
                                  }
                                  // 一旦見積側のfinal_quoteは無視する
                                  // if (field.display_id === 'final_quote') {
                                  //   if (item[key] === '1') {
                                  //     estimateItem[field.display_id] = '●'
                                  //     this.finalQuoteItems.push(item);
                                  //   }
                                  // }
                                  else {
                                    estimateItem[field.display_id] = item[key];
                                  }
                                }
                              });
                              estimateItem['i_id'] = estimateItemId;
                              estimateItem['No'] = index + 1;
                              estimateItem['rev_no'] = item.rev_no;

                              estimateItem['related_ds_items'] = {};

                              const findLinks = linkedItemResult.find(
                                (itemData: { [k: string]: any }) => itemData.i_id === estimateItemId
                              );
                              if (findLinks !== undefined) {
                                const dbs: { [k: string]: any }[] = Object.values(findLinks.result);
                                dbs.forEach(datas => {
                                  (estimateItem['related_ds_items'] as {
                                    [k: string]: { [k: string]: any }[];
                                  })[datas.d_id] = datas.items.map((item: { [k: string]: any }) => {
                                    if (item.lookup_items) {
                                      for (const [displayId, values] of Object.entries(
                                        item.lookup_items
                                      )) {
                                        item[displayId] = (values as { [k: string]: string }).i_id;
                                        item['rev_no'] = (values as { [k: string]: string }).rev_no;
                                      }
                                    }
                                    return item;
                                  });
                                });
                              }

                              this.estimateItems.push(estimateItem);
                            });
                            this.$set(projectService, 'estimateInfomation', this.estimateItems);
                            if (this.matterInfomationRegisterData.relatedItems.projectServiceOA.final_estimate_id) {
                              const estimateData = await this.estimate.getItemList(
                                this.projectId,
                                hexabaseState.datastoreIds['見積基本情報OA'],
                                {
                                  conditions: [
                                    {
                                      id: 'i_id',
                                      search_value: [this.matterInfomationRegisterData.relatedItems.projectServiceOA.final_estimate_id.i_id]
                                    }
                                  ],
                                  page: 1,
                                  per_page: 0,
                                  use_display_id: true,
                                  return_number_value: true,
                                  include_lookups: true
                                }
                              );

                              this.estimateFixecdLeasingCompany = estimateData[0].lookup_items.leasing_company_id
                            }
                            break;
                          }
                          case 't_project_credit_OA': {
                            // 案件与信OA
                            this.creditDsId = linkedItem.d_id;
                            const creditFields = linkedItem.fields;

                            this.creditItems.splice(0);
                            const iIds = linkedItem.items.map((item: any) => item.i_id as string);
                            linkedItem.items.forEach((item: any, index: number) => {
                              const creditItemId = item.i_id;
                              const creditItem: any = {};
                              Object.keys(item).map((key: string) => {
                                const field: any = Object.values(creditFields).find(
                                  (field: any) => field.f_id === key
                                );
                                if (field !== undefined) {
                                  if (field.dataType === 'dslookup') {
                                    if (field.display_id === 'credit_product_id') {
                                      // 与信商品idだった場合
                                      if (item.lookup_items && item.lookup_items[key]) {
                                        // 与信商品マスタの商品区分フィールド情報を取得
                                        const productClassificationField = Object.values(
                                          this.creditProductFields.fields
                                        ).find((field: any) => field.display_id === 'product_classification');
                                        // 表示用の商品区分を取得
                                        creditItem['product_classification'] =
                                          productClassificationField !== undefined
                                            ? item.lookup_items[key][
                                                (productClassificationField as { [k: string]: string }).field_id
                                              ]
                                            : '';
                                        // 与信商品IDをセット
                                        creditItem['credit_product_id'] = item.lookup_items[key].i_id;

                                        // 与信商品マスタの商品名フィールド情報を取得
                                        const productNameField = Object.values(
                                          this.creditProductFields.fields
                                        ).find((field: any) => field.display_id === 'prodact_name');
                                        // 表示用の商品名を取得
                                        creditItem['prodact_name'] =
                                          productNameField !== undefined
                                            ? item.lookup_items[key][
                                                (productNameField as { [k: string]: string }).field_id
                                              ]
                                            : '';

                                        // 与信商品マスタのリース会社IDフィールド情報を取得
                                        const leasingCompanyField = Object.values(
                                          this.creditProductFields.fields
                                        ).find((field: any) => field.display_id === 'leasing_company_id');
                                        // 表示用のリース会社名を取得（field_idは使用せずtitleで取得）
                                        // ※リース会社マスタのリース会社名が「タイトルに利用」になっていること
                                        creditItem['leasing_company'] = 
                                          leasingCompanyField !== undefined
                                            ? item.lookup_items[key].lookup_items[
                                                (leasingCompanyField as { [k: string]: string }).field_id
                                              ].title
                                            : '';
                                      }
                                    } else {
                                      item[key] =
                                        item.lookup_items && item.lookup_items[key]
                                          ? item.lookup_items[key].i_id
                                          : item[key];
                                      creditItem[field.display_id] = item[key];
                                    }
                                  }
                                  else {
                                    creditItem[field.display_id] = item[key];
                                  }
                                }
                              });
                              creditItem['i_id'] = creditItemId;
                              creditItem['rev_no'] = item.rev_no;

                              // 審査結果の値から紐づく選択肢を取得
                              const status = this.checkStatusItem.find(
                                (v: { [k: string]: string }) => v.text === creditItem['check_status']
                              );
                              if (status !== undefined) {
                                // 審査結果の選択肢IDをセット
                                creditItem['check_status_id'] = status.value;
                              }
                              this.creditItems.push(creditItem);
                            });

                            if (this.creditItems.length === 0) {
                              // 案件与信OAのデータがなければ空データを追加
                              this.creditItems.push(
                                Object.assign(JSON.parse(JSON.stringify(DefaultListData)), {
                                  display_order: 1
                                })
                              );
                            }
                            // 表示順での並べ替え
                            this.creditItems.sort(
                              (a: any, b: any) => a.display_order - b.display_order
                            );
                            // 事前与信タブ内一覧テーブル表示用にセット
                            this.$set(projectService, 'projectCredit', this.creditItems);
                            break;
                          }
                          default:
                            break;
                        }
                      }
                    )
                  );
                }
              }
              break;
            }
            case '2': {
              const matterLinkedItem: any = Object.values(matterLinkedItems).find(
                (matterLinkedItem: any) =>
                  matterLinkedItem.display_id === 't_project_service_fjapan'
              );
              if (matterLinkedItem) {
                // 子テーブル
                this.projectServiceDsId = matterLinkedItem.d_id;
                const item = matterLinkedItem.items[0];
                const projectServiceFJapan = this.projectServiceFJapan
                if (projectServiceFJapan !== undefined) {
                  const projectService = this.matterInfomationRegisterData.relatedItems
                    .projectServiceFJapan;
                  this.$set(projectService, 'i_id', item.i_id);
                  this.$set(projectService, 'rev_no', item.rev_no);
                  const fieldValues = projectServiceFJapan.field_values;
                  fieldValues.forEach((fieldValue: any) => {
                    if (fieldValue.value !== null) {
                      // 確定見積
                      if (fieldValue.dataType === 'dslookup') {
                        if (fieldValue.field_id === 'final_estimate_id') {
                          const estimateItem = fieldValue.value.lookup_item;
                          // 最終見積版名
                          const estimateSubjectField: any = Object.values(
                            this.estimateBasicInfoFJapanFields.fields
                          ).find((field: any) => field.display_id === 'estimate_subject');
                          this.$set(
                            projectService,
                            'estimate_subject',
                            estimateItem[estimateSubjectField.field_id]
                          );
                          const estimateVerisonNameField: any = Object.values(
                            this.estimateBasicInfoFJapanFields.fields
                          ).find((field: any) => field.display_id === 'estimate_version_name');
                          this.$set(
                            projectService,
                            'estimate_version_name',
                            estimateItem[estimateVerisonNameField.field_id]
                          );
                        }
                        this.$set(projectService, fieldValue.field_id, {
                          i_id: fieldValue.value.item_id
                        });
                      } else {
                        this.$set(projectService, fieldValue.field_id, fieldValue.value);
                      }
                    }
                  });

                  const linkedItems: any = Object.values(projectServiceFJapan.linked_items);
                  for await (const linkedItem of linkedItems) {
                    switch (linkedItem.display_id) {
                      case 't_estimate_basic_infomation_fjapan': {
                        // 見積
                        this.estimateDsId = linkedItem.d_id;
                        const estimateFields = linkedItem.fields;
                        this.estimateItems.splice(0);
                        const iIds = linkedItem.items.map((item: any) => item.i_id as string);
                        const linkedItemResult: { [k: string]: any }[] = await Promise.all(
                          iIds.map(async (id: string) => {
                            const linkedResponse = await Promise.all([
                              this.matter.getLinked(
                                this.projectId,
                                't_estimate_basic_infomation_fjapan',
                                id,
                                hexabaseState.datastoreIds['見積書発行履歴'],
                                true
                              ),
                              this.matter.getLinked(
                                this.projectId,
                                't_estimate_basic_infomation_fjapan',
                                id,
                                hexabaseState.datastoreIds[DSNames[serviceTypeList[this.serviceType]].PROJECT_SERVICE],
                                true
                              )
                            ]);
                            const response = { has_error: false, result: {} as any };
                            linkedResponse.forEach(link => {
                              if (link.result) {
                                response.has_error = link.has_error;
                                for (const [dbDisplayId, info] of Object.entries(link.result)) {
                                  response.result[dbDisplayId] = info;
                                }
                              }
                            });
                            return { ...response, ...{ i_id: id } };
                          })
                        );

                        linkedItem.items.forEach((item: any, index: number) => {
                          const estimateItemId = item.i_id;
                          const estimateItem: any = {};
                          const finalEstimateIdField: any = Object.values(
                            this.projectServiceFields[2].fields
                          ).find((field: any) => field.display_id === 'final_estimate_id');
                          if (
                            matterLinkedItem.items[0].lookup_items !== undefined &&
                            estimateItemId ===
                              matterLinkedItem.items[0].lookup_items[finalEstimateIdField.field_id]
                                .i_id
                          ) {
                            estimateItem['final_quote'] = '●';
                            this.finalQuoteItems.push(item);
                          }
                          Object.keys(item).map((key: string) => {
                            const field: any = Object.values(estimateFields).find(
                              (field: any) => field.f_id === key
                            );
                            if (field !== undefined) {
                              if (field.dataType === 'dslookup') {
                                if (field.display_id === 'commodity_id') {
                                  if (item.lookup_items && item.lookup_items[key]) {
                                    const commodityField = Object.values(
                                      this.commodityFields.fields
                                    ).find((field: any) => field.display_id === 'commodity');
                                    estimateItem['commodity_name'] =
                                      commodityField !== undefined
                                        ? item.lookup_items[key][
                                            (commodityField as { [k: string]: string }).field_id
                                          ]
                                        : '';
                                    estimateItem['commodity_id'] = item.lookup_items[key].i_id;
                                  }
                                } else {
                                  item[key] =
                                    item.lookup_items && item.lookup_items[key]
                                      ? item.lookup_items[key].i_id
                                      : item[key];
                                  estimateItem[field.display_id] = item[key];
                                }
                              }
                              else {
                                estimateItem[field.display_id] = item[key];
                              }
                            }
                          });
                          estimateItem['i_id'] = estimateItemId;
                          estimateItem['No'] = index + 1;
                          estimateItem['rev_no'] = item.rev_no;
                          estimateItem['related_ds_items'] = {};

                          const findLinks = linkedItemResult.find(
                            (itemData: { [k: string]: any }) => itemData.i_id === estimateItemId
                          );
                          if (findLinks !== undefined) {
                            const dbs: { [k: string]: any }[] = Object.values(findLinks.result);
                            dbs.forEach(datas => {
                              (estimateItem['related_ds_items'] as {
                                [k: string]: { [k: string]: any }[];
                              })[datas.d_id] = datas.items.map((item: { [k: string]: any }) => {
                                if (item.lookup_items) {
                                  for (const [displayId, values] of Object.entries(
                                    item.lookup_items
                                  )) {
                                    item[displayId] = (values as { [k: string]: string }).i_id;
                                    item['rev_no'] = (values as { [k: string]: string }).rev_no;
                                  }
                                }
                                return item;
                              });
                            });
                          }
                          this.estimateItems.push(estimateItem);
                        });

                        this.$set(projectService, 'estimateInfomation', this.estimateItems);
                        break;
                      }
                      default:
                        break;
                    }
                  }
                }
              }
              break;
            }
            case '99': {
              const matterLinkedItem: any = Object.values(matterLinkedItems).find(
                (matterLinkedItem: any) =>
                  matterLinkedItem.display_id === 't_project_service_general'
              );
              if (matterLinkedItem) {
                // 子テーブル
                this.projectServiceDsId = matterLinkedItem.d_id;
                const item = matterLinkedItem.items[0];
                const projectServiceGeneral = this.projectServiceGeneral
                if (projectServiceGeneral !== undefined) {
                  const projectService = this.matterInfomationRegisterData.relatedItems
                    .projectServiceGeneral;
                  this.$set(projectService, 'i_id', item.i_id);
                  this.$set(projectService, 'rev_no', item.rev_no);
                  const fieldValues = projectServiceGeneral.field_values;
                  fieldValues.forEach((fieldValue: any) => {
                    if (fieldValue.value !== null) {
                      // 確定見積
                      if (fieldValue.dataType === 'dslookup') {
                        if (fieldValue.field_id === 'final_estimate_id') {
                          const estimateItem = fieldValue.value.lookup_item;
                          // 最終見積版名
                          const estimateSubjectField: any = Object.values(
                            this.estimateBasicInfoGeneralFields.fields
                          ).find((field: any) => field.display_id === 'estimate_subject');
                          this.$set(
                            projectService,
                            'estimate_subject',
                            estimateItem[estimateSubjectField.field_id]
                          );
                          const estimateVerisonNameField: any = Object.values(
                            this.estimateBasicInfoGeneralFields.fields
                          ).find((field: any) => field.display_id === 'estimate_version_name');
                          this.$set(
                            projectService,
                            'estimate_version_name',
                            estimateItem[estimateVerisonNameField.field_id]
                          );
                        }
                        this.$set(projectService, fieldValue.field_id, {
                          i_id: fieldValue.value.item_id
                        });
                      } else {
                        this.$set(projectService, fieldValue.field_id, fieldValue.value);
                      }
                    }
                  });

                  const linkedItems: any = Object.values(projectServiceGeneral.linked_items);
                  for await (const linkedItem of linkedItems) {
                    switch (linkedItem.display_id) {
                      case 't_estimate_basic_infomation_general': {
                        // 見積
                        this.estimateDsId = linkedItem.d_id;
                        const estimateFields = linkedItem.fields;
                        this.estimateItems.splice(0);
                        const iIds = linkedItem.items.map((item: any) => item.i_id as string);
                        const linkedItemResult: { [k: string]: any }[] = await Promise.all(
                          iIds.map(async (id: string) => {
                            const linkedResponse = await Promise.all([
                              this.matter.getLinked(
                                this.projectId,
                                't_estimate_basic_infomation_general',
                                id,
                                hexabaseState.datastoreIds['見積書発行履歴'],
                                true
                              ),
                              this.matter.getLinked(
                                this.projectId,
                                't_estimate_basic_infomation_general',
                                id,
                                hexabaseState.datastoreIds['案件サービス別OA'],
                                true
                              )
                            ]);
                            const response = { has_error: false, result: {} as any };
                            linkedResponse.forEach(link => {
                              if (link.result) {
                                response.has_error = link.has_error;
                                for (const [dbDisplayId, info] of Object.entries(link.result)) {
                                  response.result[dbDisplayId] = info;
                                }
                              }
                            });
                            return { ...response, ...{ i_id: id } };
                          })
                        );

                        linkedItem.items.forEach((item: any, index: number) => {
                          const estimateItemId = item.i_id;
                          const estimateItem: any = {};
                          const finalEstimateIdField: any = Object.values(
                            this.projectServiceFields[99].fields
                          ).find((field: any) => field.display_id === 'final_estimate_id');
                          if (
                            matterLinkedItem.items[0].lookup_items !== undefined &&
                            estimateItemId ===
                              matterLinkedItem.items[0].lookup_items[finalEstimateIdField.field_id]
                                .i_id
                          ) {
                            estimateItem['final_quote'] = '●';
                            this.finalQuoteItems.push(item);
                          }
                          Object.keys(item).map((key: string) => {
                            const field: any = Object.values(estimateFields).find(
                              (field: any) => field.f_id === key
                            );
                            if (field !== undefined) {
                              if (field.dataType === 'dslookup') {
                                if (field.display_id === 'commodity_id') {
                                  if (item.lookup_items && item.lookup_items[key]) {
                                    const commodityField = Object.values(
                                      this.commodityFields.fields
                                    ).find((field: any) => field.display_id === 'commodity');
                                    estimateItem['commodity_name'] =
                                      commodityField !== undefined
                                        ? item.lookup_items[key][
                                            (commodityField as { [k: string]: string }).field_id
                                          ]
                                        : '';
                                    estimateItem['commodity_id'] = item.lookup_items[key].i_id;
                                  }
                                } else {
                                  item[key] =
                                    item.lookup_items && item.lookup_items[key]
                                      ? item.lookup_items[key].i_id
                                      : item[key];
                                  estimateItem[field.display_id] = item[key];
                                }
                              }
                              // 一旦見積側のfinal_quoteは無視する
                              // if (field.display_id === 'final_quote') {
                              //   if (item[key] === '1') {
                              //     estimateItem[field.display_id] = '●'
                              //     this.finalQuoteItems.push(item);
                              //   }
                              // }
                              else {
                                estimateItem[field.display_id] = item[key];
                              }
                            }
                          });
                          estimateItem['i_id'] = estimateItemId;
                          estimateItem['No'] = index + 1;
                          estimateItem['rev_no'] = item.rev_no;
                          estimateItem['related_ds_items'] = {};

                          const findLinks = linkedItemResult.find(
                            (itemData: { [k: string]: any }) => itemData.i_id === estimateItemId
                          );
                          if (findLinks !== undefined) {
                            const dbs: { [k: string]: any }[] = Object.values(findLinks.result);
                            dbs.forEach(datas => {
                              (estimateItem['related_ds_items'] as {
                                [k: string]: { [k: string]: any }[];
                              })[datas.d_id] = datas.items.map((item: { [k: string]: any }) => {
                                if (item.lookup_items) {
                                  for (const [displayId, values] of Object.entries(
                                    item.lookup_items
                                  )) {
                                    item[displayId] = (values as { [k: string]: string }).i_id;
                                    item['rev_no'] = (values as { [k: string]: string }).rev_no;
                                  }
                                }
                                return item;
                              });
                            });
                          }
                          this.estimateItems.push(estimateItem);
                        });

                        this.$set(projectService, 'estimateInfomation', this.estimateItems);
                        break;
                      }
                      default:
                        break;
                    }
                  }
                }
              }
              break;
            }
            default:
              break;
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  private async setCustomerInfo(customerItemId: string) {
    try {
      this.$store.commit('hexabase/setIsLoading', true);
      // Define variavles
      let customerDepartmentId: any = '';
      let paymentInformation: any = '';
      let installationAddress: any = '';
      // 顧客連絡先
      const customer = await this.customer.getLinkedItems(
        this.projectId,
        this.customerDsId,
        customerItemId
      );
      const telephoneNumber = customer.field_values.find(
        (field: any) => field.field_id === 'telephone_number'
      );
      this.$set(this.matterInfomationRegisterData, 'telephone_number', telephoneNumber.value);
      // 顧客部署
      if (customer.linked_items) {
        const linkedCustomerDepartment: any = Object.values(customer.linked_items).find(
          (linkedItem: any) => {
            return linkedItem.d_id === hexabaseState.datastoreIds['顧客部署マスタ'];
          }
        );
        const idFieldId = Object.keys(linkedCustomerDepartment.fields).find((key: string) => {
          return linkedCustomerDepartment.fields[key].display_id === 'id';
        });
        if (idFieldId) {
          const sortedItems = linkedCustomerDepartment.items.sort((a: any, b: any) => {
            return a[idFieldId] > b[idFieldId] ? -1 : 1;
          });
          const customerDepartmentFields = await this.matter.getFieldsData(
            this.projectId,
            hexabaseState.datastoreIds['顧客部署マスタ']
          );
          const headOfficeJudgmentFlag = Object.values(customerDepartmentFields.fields).find(
            (field) => {
              return field.display_id === 'head_office_judgment_flag';
            }
          );

          if (headOfficeJudgmentFlag) {
            const index = sortedItems.findIndex(
              (item: any) => item[headOfficeJudgmentFlag.field_id] === '本社'
            );
            if (index > -1) {
              const customerDeparment = sortedItems[index];
              customerDepartmentId = customerDeparment.i_id;
              // 自動生成部指定
              this.basicFieldsData.find(v => v.display_id === 'department_billing_address_id')![
                'props'
              ]!.value = customerDeparment;
              this.basicFieldsData.find(
                v => v.display_id === 'department_delivery_destination_id'
              )!['props']!.value = customerDeparment;
              // 請求先支払情報
              const paymentInfomationFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'payment_infomation';
                }
              );
              if (paymentInfomationFieldId) {
                const option = this.customerDepartmentPaymentInfomationItem.options.find(
                  (option: any) => {
                    return option.text === customerDeparment[paymentInfomationFieldId];
                  }
                );
                if (option) {
                  paymentInformation = option.value;
                }
              }
              // 設置先住所
              const prefecturesFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'prefectures';
                }
              );
              const municipalitiesFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'municipalities';
                }
              );
              const streetAddressFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return (
                    linkedCustomerDepartment.fields[key].display_id === 'machimura_street_address'
                  );
                }
              );
              const buildingNameFieldId = Object.keys(linkedCustomerDepartment.fields).find(
                (key: string) => {
                  return linkedCustomerDepartment.fields[key].display_id === 'building_name';
                }
              );
              if (
                prefecturesFieldId &&
                municipalitiesFieldId &&
                streetAddressFieldId &&
                buildingNameFieldId
              ) {
                installationAddress = [
                  customerDeparment[prefecturesFieldId],
                  customerDeparment[municipalitiesFieldId],
                  customerDeparment[streetAddressFieldId],
                  customerDeparment[buildingNameFieldId]
                ].join('');
              }
            }
          }
        }
      }

      this.$set(
        this.matterInfomationRegisterData,
        'department_billing_address_id',
        customerDepartmentId
      );
      this.$set(
        this.matterInfomationRegisterData,
        'department_delivery_destination_id',
        customerDepartmentId
      );
      this.$set(
        this.matterInfomationRegisterData,
        'billing_payment_information',
        paymentInformation
      );
      // 自動生成部指定
      this.basicFieldsData.find(v => v.display_id === 'billing_payment_information')![
        'props'
      ]!.value = paymentInformation;
      this.$set(this.matterInfomationRegisterData, 'installation_address', installationAddress);
      // 自動生成部指定
      this.basicFieldsData.find(v => v.display_id === 'installation_address')![
        'props'
      ]!.value = installationAddress;
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * Set tabComponents data
   */
  private async setTabItems() {
    for (const tabItem of this.materialListTabItems) {
      switch (tabItem.title) {
        case '構成表・見積作成': {
          this.$set(tabItem, 'estimateDsId', this.estimateDsId);
          switch (this.screenStructureType) {
            case '1': {
              this.$set(
                tabItem.tableParameters,
                'body',
                this.matterInfomationRegisterData.relatedItems.projectServiceOA.estimateInfomation.filter(
                  (v: { [k: string]: any }) => v.Status !== ExclusionStatus.estimate
                )
              );
              break;
            }
            case '2': {
              this.$set(
                tabItem.tableParameters,
                'body',
                this.matterInfomationRegisterData.relatedItems.projectServiceFJapan.estimateInfomation.filter(
                  (v: { [k: string]: any }) => v.Status !== ExclusionStatus.estimate
                )
              );
              break;
            }
            case '99': {
              this.$set(
                tabItem.tableParameters,
                'body',
                this.matterInfomationRegisterData.relatedItems.projectServiceGeneral.estimateInfomation.filter(
                  (v: { [k: string]: any }) => v.Status !== ExclusionStatus.estimate
                )
              );
              break;
            }
            default:
              break;
          }
          break;
        }
      }
    }
    for (const tabItem of this.matterTabItems) {
      switch (tabItem.title) {
        case '事前与信': {
          // 事前与信一覧のテーブルデータセット
          this.$set(
            tabItem.creditList.tableParameters,
            'body',
            this.matterInfomationRegisterData.relatedItems.projectServiceOA.projectCredit.filter(
              (v: { [k: string]: any }) => v.Status !== ExclusionStatus.credit
            )
          );
          this.$set(
            tabItem,
            'masterSelectItem',
            this.masterCreditProductSelectItem
          );
          break;
        }
        case '本信': {
          const projectServiceOA = this.matterInfomationRegisterData.relatedItems.projectServiceOA;
          const mainCreditStatusData = tabItem.mainCreditStatusData;
          // 本信ステータス
          this.$set(
            tabItem.masterSelectData.selectCreditStatusItem,
            'options',
            this.selectCreditStatusItem
          );
          if (projectServiceOA.true_status) {
            this.$set(mainCreditStatusData, 'true_status', projectServiceOA.true_status);
          }
          // リース会社
          if (this.matterInfomationRegisterData.relatedItems.projectServiceOA.final_estimate_id) {
            if (this.estimateFixecdLeasingCompany !== null) {
              this.$set(mainCreditStatusData, 'leasingCompany', this.estimateFixecdLeasingCompany.leasing_company);
              this.$set(mainCreditStatusData, 'telephone_number', this.estimateFixecdLeasingCompany.telephone_number);
            } else {
              this.$set(mainCreditStatusData, 'leasingCompany', '');
              this.$set(mainCreditStatusData, 'telephone_number', '');
            }
          }
          // 承認番号
          if (projectServiceOA.approval_number) {
            this.$set(mainCreditStatusData, 'approvalNumber', projectServiceOA.approval_number);
          }
          // 特記事項
          if (projectServiceOA.special_notes) {
            this.$set(mainCreditStatusData, 'specialNotes', projectServiceOA.special_notes);
          }
          break;
        }
        case '確定見積': {
          let projectService: any = undefined;
          switch (this.screenStructureType) {
            case '1': {
              projectService = this.matterInfomationRegisterData.relatedItems.projectServiceOA;
              break;
            }
            case '2': {
              projectService = this.matterInfomationRegisterData.relatedItems.projectServiceFJapan;
              break;
            }
            case '99': {
              projectService = this.matterInfomationRegisterData.relatedItems.projectServiceGeneral;
              break;
            }
            default:
              break;
          }
          if (projectService !== undefined) {
            const fixedMatterInfoData = tabItem.fixedMatterInfoData;
            Object.keys(projectService).forEach(key => {
              this.$set(fixedMatterInfoData, key, projectService[key]);
            });
            this.$set(
              tabItem,
              'finalQuoteItems',
              projectService.estimateInfomation.filter(
                (v: { [k: string]: any }) => !ExclusionStatus.fixedEstimate.includes(v.Status)
              )
            );
            this.$set(tabItem, 'fileUploadTarget', this.fileUploadTarget);
            this.$set(tabItem, 'inputFiles', this.inputFiles);
          }
          break;
        }
        default:
          break;
      }
    }
  }

  private async nonContractListAction(input: {
    name: string;
    select: { [k: string]: string }[];
  }): Promise<void> {
    switch (input.name) {
      case 'download': {
        await this.File.downLoadFiles(input.select);
        break;
      }
      case 'delete': {
        try {
          this.setLoading(true);
          await this.File.deleteFiles(
            this.projectId,
            hexabaseState.datastoreIds['契約情報'],
            this.contractInfomationItemId,
            'UpdateItem',
            'non_electronic_contract_file',
            this.nonContractFileRevNo,
            input.select,
            this.nonContractCurrentFiles
          );

          const fileList = await this.File.getFileList(
            this.projectId,
            hexabaseState.datastoreIds['契約情報'],
            this.contractInfomationItemId,
            'non_electronic_contract_file'
          );

          this.nonContractCurrentFiles = fileList.files;
          this.nonContractFileRevNo = fileList.rev;
          this.nonContractFileCount = fileList.files.length;
          const tabItem = this.matterTabItems.find((item: any) => {
            if (item.title === '契約') {
              return item;
            }
          });
          if (tabItem !== undefined) {
            tabItem.nonElectronicContractList = this.nonContractCurrentFiles;
          }
        } finally {
          this.setLoading(false);
        }
        break;
      }
    }
  }

  // 契約タブで使用するアイテム取得
  async getContractTabItemListUpdate() {
    try {
      this.$store.commit('hexabase/setIsLoading', true);
      // 契約情報取得の確認
      if (this.getContractDataFlag === true) {
        if (
          this.matterData.linked_items[
            hexabaseState.datastoreIds['契約情報']
          ].items.length !== 0
        ) {
          this.contractInfomationItemId = this.matterData.linked_items[
            hexabaseState.datastoreIds['契約情報']
          ].items[0].i_id;

          const apiResult = await this.matter.getLinkedItems(
            hexabaseState.applicationId,
            hexabaseState.datastoreIds['契約情報'],
            this.contractInfomationItemId,
            '&use_display_id=true'
          );
          this.contractInfomationItems = apiResult;
          this.getContractDataFlag = false;
        }
      }

      if (this.contractInfomationItems['field_values'] !== undefined) {
        this.documentManagementItems = this.contractInfomationItems.linked_items[
          't_documents'
        ].items;
        const results: any = [];
        const addPromises: any = [];
        for (const index in this.documentManagementItems) {
          if (this.documentManagementItems[index].matter_status_update_flag === "true") {
            this.documentManagementItems[index].matter_status_update_flag = "✔"
          } else {
            this.documentManagementItems[index].matter_status_update_flag = ""
          }
          this.documentManagementItems[index].document_status = '未取得';
          this.documentManagementItems[index].signature_request_date = this.matter.editDatetype(
            this.documentManagementItems[index].signature_request_date,
            'Asia/Tokyo',
            'yyyy/MM/dd'
          );

          let companyId = '';
          this.basicFieldsData.find((item: any) => {
            if (item.display_id === 'company_id') {
              this.masterData.m_company.body.find((recode: any) => {
                if (item.props.value.i_id === recode.i_id) {
                  companyId = recode.id;
                }
              });
            }
          });
          const param = {
            application_id: hexabaseState.applicationId,
            company_datastore_id: hexabaseState.datastoreIds['企業マスタ'],
            company_id: companyId,
            xid: this.documentManagementItems[index].xid
          };
          addPromises.push(this.simwork.triggerGetDocStatus(param));
        }
        results.push(await Promise.all(addPromises));
        for (const index in results[0]) {
          // 状態取得結果がないがない場合は状態取得エラーを表示
          if(results[0][index].data.document_status === undefined) {
            this.documentManagementItems[index].document_status = 'お問い合わせエラー'
            this.documentManagementItems[index].buttonDisabled = true;
          } else {
            this.documentManagementItems[index].document_status =
              DocumentStatus[results[0][index].data.document_status];
            if (results[0][index].data.document_status === '95') {
              this.documentManagementItems[index].buttonDisabled = false;
              const num = results[0][index].data.signing_info.length - 1;
              if(num !== -1) {
                this.documentManagementItems[index].lastSigningDatetime = results[0][index].data.signing_info[num].signing_datetime;
              }
            }
          }
        }
        const tabItem = this.matterTabItems.find((item: any) => {
          if (item.title === '契約') {
            return item;
          }
        });
        if (tabItem !== undefined) {
          tabItem.documentManagementTable.body = this.documentManagementItems;
        }
      }
    } catch (errorMessage) {
      if (errorMessage.message !== '') {
        this.setError(errorMessage.message);
      } else {
        this.setError(errorMessage);
      }
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  private async nowActiveTab(response: any, getContractDataFlag =true) {
    switch (response.title) {
      case '契約': {
        // 契約書テンプレートのデータをセレクトエリア用に加工
        const contractTemplateData: any = JSON.parse(
          JSON.stringify(
            this.masterData['m_form'].body.filter((item: any) => {
              if (item.use_scene === '契約') {
                return item;
              }
            })
          )
        );
        for (const index in contractTemplateData) {
          contractTemplateData[index].text = contractTemplateData[index].form_name;
          contractTemplateData[index].value = contractTemplateData[index].i_id;
        }
        this.contractTemplateSelectData = contractTemplateData;

        const group = this.masterData.m_signing.body.reduce(function(result: any, current: any) {
          const element = result.find(function(p: any) {
            return p.text === current.siging_template_name;
          });

          if (element === undefined) {
            result.push({
              text: current.siging_template_name,
              value: current.signing_group_id
            });
          }
          return result;
        }, []);
        this.signingGroupData = group;

        this.getContractDataFlag = getContractDataFlag;
        await this.getContractTabItemListUpdate();

        break;
      }
      default: {
        break;
      }
    }
  }

  private onChangeScreenStructureType() {
    if (this.screenStructureType !== null) {
      this.materialListTabItems.splice(0);
      this.matterTabItems.splice(0);

      const materialListTabItems = JSON.parse(JSON.stringify(MaterialListTabItems.Update[this.screenStructureType]));
      for (const [index, tabItem] of materialListTabItems.entries()) {
        this.$set(this.materialListTabItems, index, tabItem);
      }
      for (const [index, tabItem] of MatterTabItems.Update[this.screenStructureType].entries()) {
        this.$set(this.matterTabItems, index, JSON.parse(JSON.stringify(tabItem)));
      }
      this.matterInfomationRegisterData = JSON.parse(JSON.stringify(MatterInfomationRegisterData));
      this.setTabItems();
    }
  }

  @Watch('serviceType')
  private onChangeServiceType() {
    if (this.serviceType) {
      const options = this.paymentInformationLists[this.serviceType];
      this.paymentInfomationItem.options = options;
      this.$set(
        this.matterInfomationRegisterData,
        'service_type_id',
        this.masterSelectServiceTypeSelected.i_id
      );
    }
  }

  @Watch('masterSelectCustomerSelected')
  private onChangeCustomerSelected() {
    this.filterCustomeDepartment(this.masterSelectCustomerSelected.i_id);
  }

  /**
   * 顧客部署フィルタ
   */
  private filterCustomeDepartment(customerItemId: string) {
    const baseList = Object.values(this.masterData['m_customer_department'].body).map((data) => data);

    this.masterSelectCustomerDepartmentData.splice(0);
    const filteredItems = baseList.filter((customerDepartmentData: any) => {
      if (customerDepartmentData.item_links && customerDepartmentData.item_links.item_count > 0) {
        const linkItem = customerDepartmentData.item_links.links.find(
          (link: any) => link.d_id === this.customerDsId
        );
        if (linkItem && linkItem.items.length > 0) {
          return linkItem.items.some((linkItem: any) => linkItem.i_id === customerItemId);
        }
      }
    });
    filteredItems.map((customerDepartmentData: any) => {
      this.masterSelectCustomerDepartmentData.push(customerDepartmentData);
    });
    if (this.basicFieldsData.length > 0) {
      // 画面初期表示時は実行しない
      this.basicFieldsData.find(v => v.display_id === 'department_billing_address_id')![
        'props'
      ]!.body = this.masterSelectCustomerDepartmentData;
      this.basicFieldsData.find(v => v.display_id === 'department_delivery_destination_id')![
        'props'
      ]!.body = this.masterSelectCustomerDepartmentData;
      this.setCustomerInfo(customerItemId);
    }
  }

  /**
   * 見積金額（税別）算出
   */
  private calcEstimateAmount(baseObj: any) {
    let result: any = '';
    if (baseObj['total_sales_amount'] !== undefined && baseObj['discount_amount'] !== undefined) {
      result = baseObj['total_sales_amount'] + baseObj['discount_amount'];
      if (isNaN(result)) {
        result = 0;
      }
    } else {
      result = 0;
    }
    this.$set(baseObj, 'estimated_amount', result);
  }
  /**
   * 消費税額 算出
   */
  private calcTax(baseObj: any) {
    let result: any = '';
    if (baseObj['sales_tax_rate'] !== undefined && baseObj['estimated_amount'] !== undefined) {
      result =
        Math.round(baseObj['estimated_amount'] * (baseObj['sales_tax_rate'] / 100) * 10) / 10;
      if (isNaN(result)) {
        result = 0;
      }
    } else {
      result = 0;
    }
    this.$set(baseObj, 'consumption_tax', result);
  }
  /**
   * 合計金額（税込）算出
   */
  private calcTotalAmount(baseObj: any) {
    let result: any = '';
    if (baseObj['sales_tax_rate'] !== undefined && baseObj['estimated_amount'] !== undefined) {
      result = Math.floor(baseObj['estimated_amount'] * (1 + (baseObj['sales_tax_rate'] / 100)));
      if (isNaN(result)) {
        result = 0;
      }
    } else {
      result = 0;
    }
    this.$set(baseObj, 'total_fee', result);
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.matter.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * File
   */
  private async getFiles() {
    let projectService: any = undefined;
    switch (this.screenStructureType) {
      case '1': {
        projectService = this.matterInfomationRegisterData.relatedItems.projectServiceOA;
        break;
      }
      case '2': {
        projectService = this.matterInfomationRegisterData.relatedItems.projectServiceFJapan;
        break;
      }
      case '99': {
        projectService = this.matterInfomationRegisterData.relatedItems.projectServiceGeneral;
        break;
      }
      default:
        break;
    }
    const fileList = await this.File.getFileList(
      this.projectId,
      this.fileUploadTarget.datastoreId,
      this.fileUploadTarget.itemId,
      this.fileUploadTarget.fieldId
    );

    this.currentFiles = fileList.files;
    this.fileRevNo = fileList.rev;
    projectService.rev_no = this.fileRevNo;
    this.fileCount = fileList.files.length;

    this.$set(projectService, 'fileList', this.currentFiles);
  }

  private async fileUpload() {
    try {
      this.setLoading(true);

      let upfile = await this.File.uploadFiles(
        this.projectId,
        this.fileUploadTarget.datastoreId,
        this.fileUploadTarget.itemId,
        this.fileUploadTarget.fieldId,
        this.inputFiles
      );

      const current = this.currentFiles.map((file: any) => file.file_id);
      upfile = [...current, ...upfile];

      await this.File.execAction(
        this.projectId,
        this.fileUploadTarget.datastoreId,
        this.fileUploadTarget.itemId,
        'update',
        this.fileRevNo,
        upfile,
        this.fileUploadTarget.fieldId
      );
      await this.getFiles();
    } finally {
      this.clearInputFiles();
      this.setTabItems();
      this.setLoading(false);
    }
  }

  /**
   * 既存ファイルに対する処理
   * @param {{name: string, select: {[k:string]: string}[]}} - イベント返り値
   * @returns {void}
   */
  private async listAction(input: {
    name: string;
    select: { [k: string]: string }[];
  }): Promise<void> {
    if (input.name === 'download') {
      await this.File.downLoadFiles(input.select);
    }

    if (input.name === 'delete') {
      try {
        this.setLoading(true);
        await this.File.deleteFiles(
          this.projectId,
          this.fileUploadTarget.datastoreId,
          this.fileUploadTarget.itemId,
          'update',
          this.fileUploadTarget.fieldId,
          this.fileRevNo,
          input.select,
          this.currentFiles
        );
        await this.getFiles();
        this.setTabItems();
      } finally {
        this.setLoading(false);
      }
    }
  }

  private setInputFiles(files: File[]) {
    this.inputFiles = files;
    this.setTabItems();
  }

  private clearInputFiles() {
    this.inputFiles = [];
    this.setTabItems();
  }

  private setFileCount(currentFiles: Array<any>) {
    this.fileCount = currentFiles.length;
  }

  private handleScreenBack() {
    this.$router.back();
  }

  private async getSettingActionId(datastoreId: string, action_display_id: string) {
    const actionList = await this.matter.getNewActionList(datastoreId);
    const actionItem = actionList.actions.find(function(recode: any) {
      if (action_display_id === recode.display_id) {
        return recode;
      }
    });
    return actionItem?.action_id || '';
  }

  /**
   * 初回アクセス時の入力制限
   */
  private addInputProhibited(
    data: FieldChildrenProp[],
    options?: Array<string>
  ): FieldChildrenProp[] {
    return data.map((field) => {
      if (field.props === undefined) return field;
      if (options !== undefined && options.length > 0) {
        // 指定された項目の入力制限は行わない
        if (options.filter(option => field.display_id === option).length > 0) {
          return field;
        }
      }
      if (field.dataType === 'dslookup') {
        field.props!.isBtnVisible = false;
      }
      if (field.component === 'MasterSelectControl') {
        field.props!.isLeftSideInputReadOnly = true;
      }
      field.props!.isReadonly = true;
      field.props!.isDisabled = true;
      return field;
    });
  }

  /**
   * 社員IDから社員マスタの情報を取得して、
   * 取得した社員マスタの情報と企業マスタのcompany_nameから
   * 社員の所属する企業マスタの情報を取得する
   * @module findCompanyItem
   * @param findId - 社員マスタの検索に使用するid
   * @param return - 企業マスタのアイテム
   */
  private findCompanyItem(findId: string) {
    const employeeItem = this.masterData['m_employee'].body.find((recode: any) => {
      if (recode.i_id === findId) {
        return recode;
      }
    });
    if (employeeItem !== undefined) {
      const companyItem = this.masterData['m_company'].body.find((recode: any) => {
        if (recode.company_name === employeeItem.company_id) {
          return recode;
        }
      });
      return companyItem;
    }
  }

  private openGeneralDialog(title = '', message = '', cancel = false) {
    this.isGeneralDialog = true;
    this.generalDialogTitle = title;
    this.generalDialogMessage = message;
    this.generalDialogCancel = cancel;
  }

  private closeGeneralDialog(event :any) {
    this.isGeneralDialog = false
  }

  private estimateDetailTransition(event :any) {
    this.isFinalEstimateDialog = false;
  }

  private isFinalEstimate() {
    const isFinalEstimate = this.materialListTabItems[0].tableParameters.body.find((item: any) => {
      if (item.final_quote === '●') {
        return true;
      } else {
        return false
      }
    });

    return isFinalEstimate
  }

  private async sendMail(
    projectId: any,
    projectService: any,
    sendFileItemId: any,
    actionId: any,
    fileSendParams: any,
  ) {
    await this.matter.changeStatus(
      projectId,
      projectService,
      sendFileItemId,
      actionId,
      {
        is_force_update: true,
        as_params: fileSendParams
      }
    );
  }

  async formoutput(
    pId: string,
    dId: string,
    itemId: string,
    actionId: string,
    templateType: string,
    formItemId: string,
    data: any,
    fileName?: string
  ) {
    // 帳票マスタのファイルを取得
    const formMasterRecord = await this.estimate.getLinkedItems(
      hexabaseState.applicationId,
      hexabaseState.datastoreIds['帳票マスタ'],
      formItemId,
      '&use_display_id=true'
    );
    let templateFileId = '';
    if (formMasterRecord.field_values.docurain_template_file.value.length > 0) {
      templateFileId = formMasterRecord.field_values.docurain_template_file.value[0].file_id;
    } else {
      throw new Error('作成帳票にテンプレートファイルが登録されていません');
    }
    const result = await this.estimate.getForm(
      pId,
      dId,
      itemId,
      actionId,
      templateType,
      templateFileId,
      data,
      fileName,
      false,
      '',
      true
    );

    return result
  }
              

  private async signatureDetailUpdate(matterStatusUpdateFlag: any, itemId?: any, revNo?: any) {
    if (!itemId) {
      // 文書管理トランのrev_noを取得
      const itemListResult: any = await this.matter.getItemList(
        hexabaseState.applicationId,
        hexabaseState.datastoreIds['文書管理'],
        {
          'conditions': [{ 'id': 'i_id', 'search_value': [this.contractInformationDetailItemId] } ],
          'page': 1,
          'per_page': 0
        }
      );
      this.documentRevNo = Number(itemListResult[0].rev_no)
    }
    
    if (itemId) {
      this.contractInformationDetailItemId = itemId;
    }
    //文書管理トラン 選択肢項目(matter_status_update_flag)の選択肢のdisplay_idを取得
    const matterItemDetails = await this.matter.getItemDetails(hexabaseState.applicationId, hexabaseState.datastoreIds['文書管理'], this.contractInformationDetailItemId)
    const field: any = Object.values(matterItemDetails.fields).find(
      (field: any) => field.display_id === 'matter_status_update_flag'
    );
    if (matterStatusUpdateFlag === true) {
      const flag = field.options.find((option: any) => option.value === 'true');
      this.matterStatusUpdateFlag = flag.display_id;
    } else if (matterStatusUpdateFlag === false) {
      const flag = field.options.find((option: any) => option.value === 'false');
      this.matterStatusUpdateFlag = flag.display_id;
    } else {
      //「否認」のアイテムが存在する場合
      if (itemId) {
        const flag = field.options.find((option: any) => option.value === 'false');
        this.matterStatusUpdateFlag = flag.display_id;
        this.documentRevNo = Number(revNo)
      }
    }

    const updateData: any = {
      item: {} as any,
      'related_ds_items': {},
      'rev_no': this.documentRevNo
    };
    updateData['item']['matter_status_update_flag'] = this.matterStatusUpdateFlag;
    const changeStatusResult = await this.matter.changeStatus(
      hexabaseState.applicationId,
      hexabaseState.datastoreIds['文書管理'],
      this.contractInformationDetailItemId,
      'UpdateItem',
      updateData
    );
    this.$store.commit('hexabase/setIsLoading', false);
  }
  
}
